const cartChangeEvent = new Event("cartChange", { bubbles: true });

const eventNames = {
  ADD_ITEM: "cart:addItem",
  REMOVE_ITEM: "cart:removeItem",
  UPDATE_ITEM_QUANTITY: "cart:updateItemQuantity",
  OPEN_CART: "cart:open",
  CART_DATA_UPDATED: "cart:dataUpdated",
};

/**
 * Need to store the cart state globally.
 * This way when the cart is already open and we need to re-render we do not have to open and close it.
 */
window.__cartIsOpen = false;

const allFabrics = window.allFabrics.split(",");

// KEYBOARD FOCUS FIX
document.addEventListener("keyup", (e) => {
  if (e.keyCode === 9) {
    document.querySelector("body").classList.remove("no-focus-outline");
    document.querySelector("body").classList.add("focus-outline");
  }
});

document.addEventListener("click", (e) => {
  if (
    !e.target.classList.contains("product-circle-radio-label") &&
    !e.target.classList.contains("hidden-radio") &&
    !e.target.classList.contains("product-radio-label") &&
    !e.target.classList.contains("desktop-search-close") &&
    !e.target.classList.contains("desktop-search-container-content")
  ) {
    document.querySelector("body").classList.add("no-focus-outline");
    document.querySelector("body").classList.remove("focus-outline");
  }
});

window.handleize = (str) => {
  if (str) {
    return str
      .toLowerCase()
      .replace(/[^\w\u00C0-\u024f]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }
  return null;
};

const closePersonalizationModal = () => {
  const close = document.querySelector(".modal-close");
  if (close) {
    close.click();
  }
};
window.closePersonalizationModal = closePersonalizationModal;

// SMOOTH SCROLL POLYFILL
const scrollBehavior = CSS.supports("scroll-behavior: smooth");
let isMobile = window.matchMedia("(max-width: 768px)");

// polyfill to fix Safari smooth scrolling
function polyfill() {
  // aliases
  const w = window;
  const d = document;

  // return if scroll behavior is supported and polyfill is not forced
  if (
    "scrollBehavior" in d.documentElement.style &&
    w.__forceSmoothScrollPolyfill__ !== true
  ) {
    return;
  }

  // globals
  const Element = w.HTMLElement || w.Element;
  const SCROLL_TIME = 400;

  // object gathering original scroll methods
  const original = {
    scroll: w.scroll || w.scrollTo,
    scrollBy: w.scrollBy,
    elementScroll: Element.prototype.scroll || scrollElement,
    scrollIntoView: Element.prototype.scrollIntoView,
  };

  // define timing method
  const now =
    w.performance && w.performance.now
      ? w.performance.now.bind(w.performance)
      : Date.now;

  /**
   * indicates if a the current browser is made by Microsoft
   * @method isMicrosoftBrowser
   * @param {String} userAgent
   * @returns {Boolean}
   */
  function isMicrosoftBrowser(userAgent) {
    const userAgentPatterns = ["MSIE ", "Trident/", "Edge/"];

    return new RegExp(userAgentPatterns.join("|")).test(userAgent);
  }

  /*
   * IE has rounding bug rounding down clientHeight and clientWidth and
   * rounding up scrollHeight and scrollWidth causing false positives
   * on hasScrollableSpace
   */
  const ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;

  /**
   * changes scroll position inside an element
   * @method scrollElement
   * @param {Number} x
   * @param {Number} y
   * @returns {undefined}
   */
  function scrollElement(x, y) {
    this.scrollLeft = x;
    this.scrollTop = y;
  }

  /**
   * returns result of applying ease math function to a number
   * @method ease
   * @param {Number} k
   * @returns {Number}
   */
  function ease(k) {
    return 0.5 * (1 - Math.cos(Math.PI * k));
  }

  /**
   * indicates if a smooth behavior should be applied
   * @method shouldBailOut
   * @param {Number|Object} firstArg
   * @returns {Boolean}
   */
  function shouldBailOut(firstArg) {
    if (
      firstArg === null ||
      typeof firstArg !== "object" ||
      firstArg.behavior === undefined ||
      firstArg.behavior === "auto" ||
      firstArg.behavior === "instant"
    ) {
      // first argument is not an object/null
      // or behavior is auto, instant or undefined
      return true;
    }

    if (typeof firstArg === "object" && firstArg.behavior === "smooth") {
      // first argument is an object and behavior is smooth
      return false;
    }

    // throw error when behavior is not supported
    throw new TypeError(
      `behavior member of ScrollOptions ${firstArg.behavior} is not a valid value for enumeration ScrollBehavior.`,
    );
  }

  /**
   * indicates if an element has scrollable space in the provided axis
   * @method hasScrollableSpace
   * @param {Node} el
   * @param {String} axis
   * @returns {Boolean}
   */
  function hasScrollableSpace(el, axis) {
    if (axis === "Y") {
      return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
    }

    if (axis === "X") {
      return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
    }
  }

  /**
   * indicates if an element has a scrollable overflow property in the axis
   * @method canOverflow
   * @param {Node} el
   * @param {String} axis
   * @returns {Boolean}
   */
  function canOverflow(el, axis) {
    const overflowValue = w.getComputedStyle(el, null)[`overflow${axis}`];

    return overflowValue === "auto" || overflowValue === "scroll";
  }

  /**
   * indicates if an element can be scrolled in either axis
   * @method isScrollable
   * @param {Node} el
   * @param {String} axis
   * @returns {Boolean}
   */
  function isScrollable(el) {
    const isScrollableY = hasScrollableSpace(el, "Y") && canOverflow(el, "Y");
    const isScrollableX = hasScrollableSpace(el, "X") && canOverflow(el, "X");

    return isScrollableY || isScrollableX;
  }

  /**
   * finds scrollable parent of an element
   * @method findScrollableParent
   * @param {Node} el
   * @returns {Node} el
   */
  function findScrollableParent(el) {
    while (el !== d.body && isScrollable(el) === false) {
      el = el.parentNode || el.host;
    }

    return el;
  }

  /**
   * self invoked function that, given a context, steps through scrolling
   * @method step
   * @param {Object} context
   * @returns {undefined}
   */
  function step(context) {
    const time = now();
    let value;
    let currentX;
    let currentY;
    let elapsed = (time - context.startTime) / SCROLL_TIME;

    // avoid elapsed times higher than one
    elapsed = elapsed > 1 ? 1 : elapsed;

    // apply easing to elapsed time
    value = ease(elapsed);

    currentX = context.startX + (context.x - context.startX) * value;
    currentY = context.startY + (context.y - context.startY) * value;

    context.method.call(context.scrollable, currentX, currentY);

    // scroll more if we have not reached our destination
    if (currentX !== context.x || currentY !== context.y) {
      w.requestAnimationFrame(step.bind(w, context));
    }
  }

  /**
   * scrolls window or element with a smooth behavior
   * @method smoothScroll
   * @param {Object|Node} el
   * @param {Number} x
   * @param {Number} y
   * @returns {undefined}
   */
  function smoothScroll(el, x, y) {
    let scrollable;
    let startX;
    let startY;
    let method;
    const startTime = now();

    // define scroll context
    if (el === d.body) {
      scrollable = w;
      startX = w.scrollX || w.pageXOffset;
      startY = w.scrollY || w.pageYOffset;
      method = original.scroll;
    } else {
      scrollable = el;
      startX = el.scrollLeft;
      startY = el.scrollTop;
      method = scrollElement;
    }

    // scroll looping over a frame
    step({
      scrollable,
      method,
      startTime,
      startX,
      startY,
      x,
      y,
    });
  }

  // ORIGINAL METHODS OVERRIDES
  // w.scroll and w.scrollTo
  w.scroll = w.scrollTo = function () {
    // avoid action when no arguments are passed
    if (arguments[0] === undefined) {
      return;
    }

    // avoid smooth behavior if not required
    if (shouldBailOut(arguments[0]) === true) {
      original.scroll.call(
        w,
        arguments[0].left !== undefined
          ? arguments[0].left
          : typeof arguments[0] !== "object"
            ? arguments[0]
            : w.scrollX || w.pageXOffset,
        // use top prop, second argument if present or fallback to scrollY
        arguments[0].top !== undefined
          ? arguments[0].top
          : arguments[1] !== undefined
            ? arguments[1]
            : w.scrollY || w.pageYOffset,
      );

      return;
    }

    // LET THE SMOOTHNESS BEGIN!
    smoothScroll.call(
      w,
      d.body,
      arguments[0].left !== undefined
        ? ~~arguments[0].left
        : w.scrollX || w.pageXOffset,
      arguments[0].top !== undefined
        ? ~~arguments[0].top
        : w.scrollY || w.pageYOffset,
    );
  };

  // w.scrollBy
  w.scrollBy = function () {
    // avoid action when no arguments are passed
    if (arguments[0] === undefined) {
      return;
    }

    // avoid smooth behavior if not required
    if (shouldBailOut(arguments[0])) {
      original.scrollBy.call(
        w,
        arguments[0].left !== undefined
          ? arguments[0].left
          : typeof arguments[0] !== "object"
            ? arguments[0]
            : 0,
        arguments[0].top !== undefined
          ? arguments[0].top
          : arguments[1] !== undefined
            ? arguments[1]
            : 0,
      );

      return;
    }

    // LET THE SMOOTHNESS BEGIN!
    smoothScroll.call(
      w,
      d.body,
      ~~arguments[0].left + (w.scrollX || w.pageXOffset),
      ~~arguments[0].top + (w.scrollY || w.pageYOffset),
    );
  };

  // Element.prototype.scroll and Element.prototype.scrollTo
  Element.prototype.scroll = Element.prototype.scrollTo = function () {
    // avoid action when no arguments are passed
    if (arguments[0] === undefined) {
      return;
    }

    // avoid smooth behavior if not required
    if (shouldBailOut(arguments[0]) === true) {
      // if one number is passed, throw error to match Firefox implementation
      if (typeof arguments[0] === "number" && arguments[1] === undefined) {
        throw new SyntaxError("Value could not be converted");
      }

      original.elementScroll.call(
        this,
        // use left prop, first number argument or fallback to scrollLeft
        arguments[0].left !== undefined
          ? ~~arguments[0].left
          : typeof arguments[0] !== "object"
            ? ~~arguments[0]
            : this.scrollLeft,
        // use top prop, second argument or fallback to scrollTop
        arguments[0].top !== undefined
          ? ~~arguments[0].top
          : arguments[1] !== undefined
            ? ~~arguments[1]
            : this.scrollTop,
      );

      return;
    }

    const { left } = arguments[0];
    const { top } = arguments[0];

    // LET THE SMOOTHNESS BEGIN!
    smoothScroll.call(
      this,
      this,
      typeof left === "undefined" ? this.scrollLeft : ~~left,
      typeof top === "undefined" ? this.scrollTop : ~~top,
    );
  };

  // Element.prototype.scrollBy
  Element.prototype.scrollBy = function () {
    // avoid action when no arguments are passed
    if (arguments[0] === undefined) {
      return;
    }

    // avoid smooth behavior if not required
    if (shouldBailOut(arguments[0]) === true) {
      original.elementScroll.call(
        this,
        arguments[0].left !== undefined
          ? ~~arguments[0].left + this.scrollLeft
          : ~~arguments[0] + this.scrollLeft,
        arguments[0].top !== undefined
          ? ~~arguments[0].top + this.scrollTop
          : ~~arguments[1] + this.scrollTop,
      );

      return;
    }

    this.scroll({
      left: ~~arguments[0].left + this.scrollLeft,
      top: ~~arguments[0].top + this.scrollTop,
      behavior: arguments[0].behavior,
    });
  };

  // Element.prototype.scrollIntoView
  Element.prototype.scrollIntoView = function () {
    // avoid smooth behavior if not required
    if (shouldBailOut(arguments[0]) === true) {
      original.scrollIntoView.call(
        this,
        arguments[0] === undefined ? true : arguments[0],
      );

      return;
    }

    // LET THE SMOOTHNESS BEGIN!
    const scrollableParent = findScrollableParent(this);
    const parentRects = scrollableParent.getBoundingClientRect();
    const clientRects = this.getBoundingClientRect();

    if (scrollableParent !== d.body) {
      // reveal element inside parent
      smoothScroll.call(
        this,
        scrollableParent,
        scrollableParent.scrollLeft + clientRects.left - parentRects.left,
        scrollableParent.scrollTop + clientRects.top - parentRects.top,
      );

      // reveal parent in viewport unless is fixed
      if (w.getComputedStyle(scrollableParent).position !== "fixed") {
        w.scrollBy({
          left: parentRects.left,
          top: parentRects.top,
          behavior: "smooth",
        });
      }
    } else {
      // reveal element in viewport
      w.scrollBy({
        left: clientRects.left,
        top: clientRects.top,
        behavior: "smooth",
      });
    }
  };
}

if (typeof exports === "object" && typeof module !== "undefined") {
  // commonjs
  module.exports = { polyfill };
} else {
  // global
  polyfill();
}

// GLOBAL VARIABLES
const onDesktop = matchMedia("(pointer:fine)").matches;

// ENTER EVENT
window.enterEvent = (e) => {
  if (e.repeat) {
    e.preventDefault();
  }
  const item = e.target;
  if (e.keyCode === 13 || e.keyCode === 32) {
    e.preventDefault();
    item.click();
  }
};

/**
 * Updates the swatch messaging that appears on cart page.
 * This message is initially rendered from cart--swatch-messaging.liquid
 *
 * @param {object} cart - The cart object.
 */
const updateSwatchMessaging = (cart) => {
  if (cart && cart.items !== undefined && cart.items !== null) {
    const swatchTrioMessage = document.getElementById("swatch-trio-message");

    // Condition is met when on the cart page.
    if (swatchTrioMessage) {
      const hasSwatch = cart.items.some(
        (item) => item.product_type === "Swatch",
      );

      if (hasSwatch === false) {
        swatchTrioMessage.classList.add("hidden");
      }
    }
  }
};

window.addEventListener(eventNames.OPEN_CART, () => {
  /**
   * Only open the cart if its closed.
   */
  if (window.location.pathname.includes("/cart")) return;
  if (!window.__cartIsOpen) {
    openDrawer(document.getElementById("cart-button").dataset.drawer);
  }
});

window.addEventListener(eventNames.CART_DATA_UPDATED, ({ detail }) => {
  const { cart } = detail;
  if (detail.action === "add" && detail.data) {
    const { addToCartResponse, klaviyoProduct } = detail.data;
    cartSuccess(addToCartResponse, cart, klaviyoProduct);
    window.cart = cart;
  }
  /**
   * Build the cart's UI then open it.
   */
  setTimeout(() => {
    buildMiniCart(cart);
    updateSwatchMessaging(cart);
    window.dispatchEvent(new CustomEvent(eventNames.OPEN_CART));
  }, 10);
});

// changeCartQuantityWithKey: Helper function for removing AJAX cart item.
const removeItemFromAjaxCart = async (variantId, item, e) => {
  const isRemove = e.currentTarget.classList.contains("ajax-remove");
  if (isRemove) {
    item.quantity = 0;
  }
  const { key } = item;
  return await fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(item),
  })
    .then((res) => res.json())
    .then((response) => {
      if (localStorage.atc_attribution) {
        const attribution = JSON.parse(localStorage.atc_attribution);
        if (attribution[key]) {
          delete attribution[key];
        }
        localStorage.atc_attribution = JSON.stringify(attribution);
      }

      e.target.dispatchEvent(cartChangeEvent);

      if (isRemove) {
        const cartAddItemEvent = new CustomEvent(eventNames.REMOVE_ITEM, {
          detail: {
            data: {
              ...item,
              variantId,
              cart: response,
            },
          },
        });
        window.dispatchEvent(cartAddItemEvent);
      }
      window.cart = response;
      return response;
    })
    .catch((error) => {
      console.error("Error:", error);
    });
};

// CHANGE LINE ITEM QUANTITY USING THE LINE ITEM'S KEY VALUE
const changeCartQuantityWithKey = (e) => {
  const line = e.currentTarget;
  const { key, variantId } = line.dataset;
  let quantity = line.value;

  if (isNaN(quantity)) {
    quantity = 1;
    line.value = 1;
  }
  const item = {
    id: key,
    quantity,
    variantId,
  };
  return window.removeFromStorefrontCart(item);
};

// Cart API Ajax update cart items call
const incrementLineQuantity = (e) => {
  const button = e.currentTarget;
  return window.updateCartLine(button);
};

// Reload cart functions after building Ajax or Storefront Cart APIs.
const reloadCartFunctions = () => {
  document.querySelectorAll(".ajax-remove").forEach((remover) => {
    remover.addEventListener("click", changeCartQuantityWithKey);
    remover.addEventListener("keydown", enterEvent);
  });
  document.querySelectorAll(".ajax-change-quantity").forEach((changer) => {
    changer.addEventListener("change", changeCartQuantityWithKey);
  });
  document.querySelectorAll(".mini-cart-incrementor").forEach((incrementor) => {
    incrementor.addEventListener("click", incrementLineQuantity);
    incrementor.addEventListener("keydown", enterEvent);
  });
};
window.reloadCartFunctions = reloadCartFunctions;

const checkForSwatchBuyer = (cart) => {
  const mainHeader = document.getElementById("header");
  const blogHeader = document.getElementById("birdy-edit-header");
  const customerTags = mainHeader
    ? mainHeader.dataset.customertags
    : blogHeader.dataset.customertags;
  const maxSwatches = Number(window.maxSwatchesForDiscount);

  // Audit cart to make sure it doesn't exceed the max free swatch limit
  const isOverMaxSwatchLimit = (cart, maxSwatch) => {
    if (cart.items && cart.items.length <= 0) return;
    const swatchItems = cart.items.filter((item) =>
      item.product_type.includes("Swatch"),
    );
    const totalSwatchQuantity = swatchItems.reduce(
      (total, item) => total + item.quantity,
      0,
    );
    return totalSwatchQuantity > maxSwatch;
  };

  return (customerTags !== null && customerTags.includes("swatch-buyer")) ||
    isOverMaxSwatchLimit(cart, maxSwatches)
    ? false
    : true;
};

// Helper function used to shuffle `getCartUpsells`
const shuffle = (array) => {
  let currentIndex = array.length;
  let randomIndex;
  // While there remain elements to shuffle...
  while (currentIndex != 0) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }

  return array;
};

// THROTTLE ADD TO CART BY 500 MS
const throttleAddToCart = throttle((...args) => {
  window.addToStorefrontCart(...args);
}, 500);

// Helper function used in `getCartUpsells`
const upsellAtc = (e) => {
  const button = e.currentTarget;
  window.focusReturn = e.currentTarget;
  button.innerHTML = `ADDING &hellip;`;
  const id = button.dataset.handle;
  let body;

  const attributes = button.dataset.location && [
    { key: "_location", value: button.dataset.location },
    { key: "_type", value: button.dataset.quicktype },
  ];
  if (button.dataset.finalSale && button.dataset.finalSale === "true") {
    attributes.push({
      key: "is_final_sale",
      value: button.dataset.finalSale,
    });
  }
  body = {
    lines: [
      {
        merchandiseId: id,
        quantity: 1,
        attributes,
      },
    ],
  };

  throttleAddToCart(body, button);
};
window.upsellAtc = upsellAtc;

// BUILD CART FUNCTION
const buildMiniCart = (ajaxCart) => {
  // Patch fix for Rush Fee qty alignment. On Storefront API, we're adding the Rush Fee product with our cart actions, while AJAX requires auditing in `cart.utils.js`. If we do not use the prop cart for AJAX, the Rush Fee products are one call behind.
  const cart = window.cart;
  document.querySelectorAll(".cart-contents-icon").forEach((icon) => {
    icon.innerHTML = `${cart.item_count}`;
  });
  const cartHeader = `Your Bag (${cart.item_count})`;
  let cartContainer = ``;
  let cartFooter = ``;
  let cartMixNote = ``;
  const mixArray = [];

  let cartPageContent = ``;
  const cartPage = document.getElementById("cart-summary");
  if (cart.item_count > 0) {
    const subtotal = cart.items_subtotal_price;
    document.getElementById("cart-tray-upsell-body").style.display = "block";
    getCartUpsells(cart);

    cart.items.forEach((item) => {
      const isItemRushFee =
        item.product_title.includes("Rush Fee") ||
        item.title.includes("Rush Fee");
      const isItemSwatchBook = item.product_type === "Swatch Book";
      const itemHandle = item.vendor.includes("Birdy Grey Suits")
        ? `https://suits.birdygrey.com${item.url}`
        : item.url;

      let price = item.final_line_price;
      let originalPrice = item.original_line_price;
      if (item.price > item.final_price) {
        price = item.final_line_price;
      } else if (!item.product_type.includes("Swatch")) {
        price = item.original_line_price;
      }

      if (item.product_type.includes("Swatch")) {
        price = parseInt(price / 100);
      } else {
        price = price % 100 > 0 ? (price / 100).toFixed(2) : price / 100;
      }

      originalPrice =
        originalPrice % 100 > 0
          ? (originalPrice / 100).toFixed(2)
          : originalPrice / 100;
      let priceContainer = ``;

      if (originalPrice > price) {
        priceContainer = `
        <span class="text-brand-darkerMocha line-through decoration-2" aria-label="Original price $${originalPrice}">
          <span class="text-brand-deepMocha-75">$${originalPrice}</span>
        </span>
        <span aria-label="Sale price $${price}">$${price}</span>
        `;
      } else {
        priceContainer = `$${price}`;
      }
      let properties = ``;
      let pageProperties = ``;
      let customization = ``;
      let ajaxFinalSale = ``;
      let finalSale = ``;

      if (item.properties !== null) {
        // Handle rush fee properties separately
        if (isItemRushFee) {
          const productNameWithoutColor =
            item.properties._productNameWithoutColor;
          const variantName =
            item.properties._variantName.split("/ Rush Production")[0];

          properties += `
          <div class="cart-item-info">
            <p class="cart-item-title capitalize">${productNameWithoutColor}</p>
            <p class="cart-item-variants">${variantName}</p>
          </div>
          `;
          pageProperties += `
          <div class="cart-item-info">
            <p class="cart-item-title capitalize">${productNameWithoutColor}</p>
            <p class="cart-item-variants">${variantName}</p>
          </div>
          `;
        }
        // Handle all other products' properties
        else {
          const props = Object.keys(item.properties).map((key) => [
            key,
            item.properties[key],
          ]);
          props.forEach((property) => {
            if (property[0] == "Customization") {
              customization += property[1];
            } else if (
              property[0] == "CustomizationFont" ||
              property[0] == "CustomizationColor"
            ) {
              customization += ` / ${property[1].split("(")[0].trim()} `;
            }
          });

          props.forEach((property) => {
            /**
             * This handles the mix messaging UI
             */
            if (
              property[0] === "MADE-TO-ORDER" ||
              property[0] === "_MADE-TO-ORDER" ||
              property[0] === "PREORDER" ||
              property[0] === "_PREORDER"
            ) {
              mixArray.push("preorder");
            } else if (
              property[0] === "READY TO SHIP" ||
              property[0] === "_READY-TO-SHIP"
            ) {
              mixArray.push("ready");
            }

            /**
             * property[0] represents the production timeline of the item (preorder, made-to-order)
             *
             * property[1] represents the description correlated to that type (Expected to deliver by...)
             *
             * Item is made to order or preorder, append the HTML with the associated property description
             * */
            if (
              property[0] === "MADE-TO-ORDER" ||
              property[0] === "_MADE-TO-ORDER"
            ) {
              /**
               * The _PROMISED_BY_DATE is created from addPromisedByDateProperty in cart.utils.js
               *
               * The value is either calculated with the item's production_days metafield,
               *
               * or with the fallback values in the delayed delivery metaobject.
               */
              const promisedByDate = item.properties._PROMISED_BY_DATE;

              properties = `<div class="cart-item-estimation text-sm font-semibold not-italic">Expected to arrive between ${promisedByDate}</div>`;
              pageProperties = `<div class="cart-item-estimation-date text-sm font-semibold not-italic">Expected to arrive between ${promisedByDate}</div>`;
            } else if (
              property[0] === "PREORDER" ||
              property[0] === "_PREORDER"
            ) {
              properties = `<div class="cart-item-estimation text-sm font-semibold">${property[1]}</div>`;
              pageProperties = `<div class="cart-item-estimation-date text-sm font-semibold">${property[1]}</div>`;
            } else if (
              /**
               * Item is ready to ship
               */
              property[0] === "READY TO SHIP" ||
              property[0] === "_READY-TO-SHIP"
            ) {
              properties = `<div class="cart-item-estimation font-semibold text-sm">${property[1]}</div>`;
              pageProperties = `<div class="cart-item-estimation font-semibold text-sm">${property[1]}</div>`;
            } else if (
              (property[0] === "_is_final_sale" ||
                property[0] === "is_final_sale") &&
              property[1] === "true" &&
              !item.variant_title?.includes("Not Personalized")
            ) {
              ajaxFinalSale += `Final Sale`;
              finalSale += `Final Sale`;
            }
          });
        }
      }

      /**
       * Builds the subhead for a cart item.
       * @param {Object} cartItem - The item object containing details such as key and title.
       * @returns {string} HTML string representing the quantity label.
       */
      const buildCartItemSubhead = (cartItem) => {
        if (
          cartItem.variant_title == null ||
          cartItem.title.includes("Gift Card") ||
          cartItem.title.includes("Rush Fee") ||
          cartItem.product_title.includes("Rush Fee")
        )
          return "";
        let subhead = cartItem.variant_title.includes("Default Title")
          ? ""
          : cartItem.variant_title;

        const rushFeeOptionName = window.dualSaleRushOptionName;
        if (subhead.includes(rushFeeOptionName)) {
          subhead = subhead.split(` / ${rushFeeOptionName}`)[0];
        }

        return `<div class="cart-item-variants uppercase">${subhead}</div>`;
      };

      /**
       * Builds the quantity label for a cart item.
       * @param {Object} cartItem - The item object containing details such as key and title.
       * @param {string} cartType - The type of cart ('mini', 'page').
       * @param {boolean} itemIsRushFee - Indicates if the item is a rush fee item.
       * @returns {string} HTML string representing the quantity label.
       */
      const buildCartItemQuantity = (cartItem, cartType, itemIsRushFee) => {
        const keyPrefix = cartType === "mini" ? "" : "cart-";

        return `<label class="cart-item-qty text-sm font-semibold uppercase md:text-base" for="${keyPrefix}${cartItem.key}-quantity" aria-label="Quantity for ${cartItem.title}">${itemIsRushFee ? `Quantity: ${cartItem.quantity}` : "Quantity"}</label><br>`;
      };

      /**
       * Builds the controls for adjusting item quantities in the cart and a button to remove the item.
       * @param {Object} cartItem - The item object containing details such as key, title, quantity.
       * @param {string} cartType - The type of cart ('mini', 'page').
       * @param {boolean} itemIsRushFee - Indicates if the item is a rush fee item.
       * @returns {string} HTML string representing the quantity controls if not a rush fee item, otherwise an empty string.
       */
      const buildCartItemControls = (cartItem, cartType, itemIsRushFee) => {
        if (itemIsRushFee) return "";
        const keyPrefix = cartType === "mini" ? "" : "cart-";
        const idSuffix = cartType === "mini" ? "remove" : "remover";

        return `
          <div class="flex items-center">
            <p role="status" class="qtv-vlu sr-only"></p>
            <div class="relative w-max">
              <div role="button" tabindex="0" data-key="${cartItem.key}" data-item="${keyPrefix}${cartItem.key}-quantity" data-key-prefix="${keyPrefix}" data-type="decrement" aria-label="Decrement quantity for ${cartItem.title}" data-variant-id="${cartItem.id}" class="mini-cart-incrementor incrementor top absolute left-0.5 flex h-full w-6 cursor-pointer items-center justify-center md:left-2.5">&minus;</div>
              <div role="button" tabindex="0" data-item="${keyPrefix}${cartItem.key}-quantity" data-key-prefix="${keyPrefix}" data-type="increment" aria-label="Increment quantity for ${cartItem.title}" data-variant-id="${cartItem.id}" data-key="${cartItem.key}" class="mini-cart-incrementor decrementor top absolute right-0.5 flex h-full w-6 cursor-pointer items-center justify-center md:right-2.5">&plus;</div>
              <input autocomplete="off" pattern="\\d*" id="${keyPrefix}${cartItem.key}-quantity" class="ajax-change-quantity h-6 w-24 cursor-pointer rounded-full border border-solid border-brand-darkerMocha px-0 py-0.5 text-center text-base leading-none md:h-8" data-key="${cartItem.key}" type="number" value="${cartItem.quantity}" data-variant-id="${cartItem.id}" />
            </div>
            <div id="${cartItem.key}-${idSuffix}" tabindex="0" role="button" aria-label="Remove ${cartItem.title} from cart" data-key="${cartItem.key}" data-variant-id="${cartItem.id}" value="${cartItem.quantity}" class="ajax-remove ml-4 cursor-pointer text-xs uppercase underline underline-offset-2 md:text-sm duration-200 hover:underline-offset-[3px]">
              Remove
            </div>
          </div>
        `;
      };

      cartContainer += `
        <div id="line-item-${item.key}" class="line-item grid gap-4">
          <div class="w-full h-max">
          ${isItemRushFee || isItemSwatchBook ? `<span>` : `<a href="${itemHandle}">`}
              <picture>
                <img class="h-full w-full object-cover" alt="${item.product_title}" width="${item?.featured_image.width}" height="${item?.featured_image.height}" src="${item.image}" loading="lazy"/>
              </picture>
          ${isItemRushFee || isItemSwatchBook ? `</span>` : `</a>`}
          </div>
          <div class="text-sm md:text-base flex flex-col justify-between">
            <div class="cart-item-content">
              <div class="font-semibold capitalize">${item.product_title}</div>
              ${buildCartItemSubhead(item)}
              <div class="cart-item-customizations capitalize text-xs md:text-sm">${customization}</div>
              <div class="cart-item-price font-semibold space-x-1">${priceContainer}</div>
                ${properties}
              <div class="final-sale-note text-brand-errorText font-semibold text-sm">${ajaxFinalSale}</div>
            </div>
            <div class="cart-item-qty">
              <div class="mt-2 text-xs uppercase md:text-sm space-y-1">
                ${buildCartItemQuantity(item, "mini", isItemRushFee)}
                ${buildCartItemControls(item, "mini", isItemRushFee)}
              </div>
            </div>
          </div>
          <div id="availability-error-${item.key}" class="availability-error bg-red-600 col-span-full hidden ">
                      <div class="flex items-center space-x-2">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect width="16" height="16" rx="8" fill="#A64E47"/>
                          <path d="M7.35262 9.60997L7.17762 3.36597H8.79462L8.61962 9.60997H7.35262ZM7.98962 12.634C7.68162 12.634 7.42728 12.5383 7.22662 12.347C7.03062 12.1556 6.93262 11.913 6.93262 11.619C6.93262 11.3343 7.03062 11.094 7.22662 10.898C7.42728 10.6973 7.68162 10.597 7.98962 10.597C8.29762 10.597 8.55428 10.6973 8.75962 10.898C8.96495 11.094 9.06762 11.3343 9.06762 11.619C9.06762 11.913 8.96495 12.1556 8.75962 12.347C8.55428 12.5383 8.29762 12.634 7.98962 12.634Z" fill="white"/>
                        </svg>
                        <span class="ml-2 text-[14px] not-italic font-semibold leading-[20px] tracking-[0.24px] text-[#A64E47]">
                          You’ve reached the max quantity in stock.
                        </span>
                      </div>
                    </div>
        </div>
      `;

      if (cartPage) {
        cartPageContent += `
          <div id="line-${item.key}" class="cart-line-item m-wrapper relative grid grid-cols-2fr-3fr items-center gap-4 border-b border-solid border-brand-deepMocha-50 py-4 first:pt-0 last-of-type:border-0 md:grid-cols-10vw-10rem first:mt-4" data-key="${item.key}">
            <div>
              ${isItemRushFee ? `<span>` : `<a href="${itemHandle}">`}
                <picture>
                  <img class="object-cover size-full" alt="${item.product_title}" width="${item.image.width}" height="${item.image.height}" src="${item.image}" loading="lazy" />
                </picture>
              ${isItemRushFee ? `</span>` : `</a>`}
            </div>
            <div class="flex flex-col h-full justify-between text-base">
              <div class="cart-item-content">
                <div class="cart-item-title font-semibold capitalize">${item.product_title}</div>
                ${buildCartItemSubhead(item)}
                <div class="cart-item-customizations text-sm capitalize">${customization}</div>
                <div class="cart-item-price space-x-1 font-semibold">
                  ${priceContainer}
                </div>
                ${pageProperties}
                <div class="final-sale-note text-brand-errorText font-semibold text-sm">${finalSale}</div>
              </div>
                <div>
                  <div class="cart-item-qty mt-2 space-y-1">
                    ${buildCartItemQuantity(item, "page", isItemRushFee)}
                    ${buildCartItemControls(item, "page", isItemRushFee)}
                  </div>
                </div>
              </div>
              <div id="availability-error-${item.key}" class="availability-error bg-red-600 col-span-full hidden ">
                      <div class="flex items-center space-x-2">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect width="16" height="16" rx="8" fill="#A64E47"/>
                          <path d="M7.35262 9.60997L7.17762 3.36597H8.79462L8.61962 9.60997H7.35262ZM7.98962 12.634C7.68162 12.634 7.42728 12.5383 7.22662 12.347C7.03062 12.1556 6.93262 11.913 6.93262 11.619C6.93262 11.3343 7.03062 11.094 7.22662 10.898C7.42728 10.6973 7.68162 10.597 7.98962 10.597C8.29762 10.597 8.55428 10.6973 8.75962 10.898C8.96495 11.094 9.06762 11.3343 9.06762 11.619C9.06762 11.913 8.96495 12.1556 8.75962 12.347C8.55428 12.5383 8.29762 12.634 7.98962 12.634Z" fill="white"/>
                        </svg>
                        <span class="ml-2 text-[14px] not-italic font-semibold leading-[20px] tracking-[0.24px] text-[#A64E47]">
                          You’ve reached the max quantity in stock.
                        </span>
                      </div>
                    </div>
        </div>
            </div>
        `;
      }
    });

    cartFooter += `
    <div class="mb-4 flex w-full justify-between text-base font-semibold uppercase">
      <div>Subtotal</div>
      <div class="cart-subtotal" id="cart-subtotal">
        $${Math.floor(subtotal / 100)}
      </div>
    </div>
    <a class="review-your-order w-full button button-primary" href="/cart">Review Your Order</a>
    `;

    const hasPreorder = mixArray.includes("preorder");
    const hasReady = mixArray.includes("ready");

    if (hasPreorder && hasReady) {
      cartMixNote += `
        <div class="${!cartPage && "p-4 pb-0"}">
          <div class="border border-solid border-brand-deepMocha-50 bg-white px-3 py-4">
            <h3 class="mb-2 font-body text-base font-bold leading-5 tracking-wide md:text-lg md:leading-6">
              Your Bag contains items that will ship separately.
            </h3>

            <p class="m-0 text-sm leading-tight tracking-wide md:text-base md:leading-5">
              You’ll receive Rush and Ready to Ship items first. Preorder, Made-On-Demand and Standard
              production items will ship separately.
            </p>
          </div>
        </div>
      `;
    } else {
      cartMixNote += ``;
    }

    const miniCartUpsellCarousel = document.getElementById(
      "mini-cart-upsell-carousel",
    );
    const cartBody = document.getElementById("cart-tray-upsell-body");
    const cartFooterContents = document.getElementById(
      "mini-cart-footer-contents",
    );
    miniCartUpsellCarousel.classList.toggle(
      "justify-around",
      cart.item_count === 0,
    );
    cartFooterContents.classList.toggle("my-4", cart.item_count > 0);

    if (cartPage) {
      document.getElementById("line-item-container").innerHTML =
        cartPageContent;
      document.getElementById("cart-page-tray-note").innerHTML = cartMixNote;
      const finalPrice = Math.floor(subtotal / 100);
      document.getElementById("cart-item-count").innerText =
        `${cart.item_count} ${cart.item_count === 1 ? "item" : "items"}`;
      document.getElementById("cart-subtotal-cart-page").innerText =
        `$${finalPrice}`;
      reloadCartFunctions();
    }
    miniCartUpsellCarousel.classList.add("grid");
    miniCartUpsellCarousel.classList.add("gap-4");
    miniCartUpsellCarousel.classList.remove("flex");
    miniCartUpsellCarousel.style.gridAutoFlow = "column";
    cartBody.classList.add("p-4");
    cartBody.classList.remove("mini-cart-empty-body");
    document.getElementById("cart-need-little-more").classList.remove("none");
  } else {
    const emptyMiniCartMessage = `<div class="cart-empty-message space-y-1 my-4">
      <p class="mb-1 text-center uppercase">Your bag is empty</p>
      <p class="h3 my-1 text-center">Find your perfect fit</p>
    </div>`;
    const shopBestSellersButton = `<div>
      <a class="w-full button button-primary" href="/collections/best-selling-dresses">
        Shop Best Sellers
      </a>
    </div>`;
    const emptyCartPageMessage = `<div class="flex flex-col items-center gap-4 text-center font-semibold p-16">
      <div>Your bag is empty, but you can change that.</div>
      <a href="/collections/bridesmaid-dresses" class="no-underline">
        <button class="button button-secondary">Shop Dresses</button>
      </a>
    </div>`;

    cartContainer += emptyMiniCartMessage;

    document.getElementById("cart-tray-upsell-body").style.display = "none";
    cartFooter += shopBestSellersButton;
    if (cartPage) {
      document.querySelector("#line-item-container").innerHTML =
        emptyCartPageMessage;
    }
    const miniCartUpsellCarousel = document.getElementById(
      "mini-cart-upsell-carousel",
    );
    const cartBody = document.getElementById("cart-tray-upsell-body");
    const cartFooterContents = document.getElementById(
      "mini-cart-footer-contents",
    );
    miniCartUpsellCarousel.classList.add("justify-around");
    cartFooterContents.classList.add("my-4");

    // When cart is empty, reset to the initial upsells generated from cart--initial-upsells.liquid
    miniCartUpsellCarousel.innerHTML = window.upsells;
    miniCartUpsellCarousel.classList.remove("grid");
    miniCartUpsellCarousel.classList.remove("gap-4");
    miniCartUpsellCarousel.classList.add("flex");
    miniCartUpsellCarousel.style.gridAutoFlow = "unset";
    cartBody.style.display = "block";
    cartBody.classList.remove("p-4");
    cartBody.classList.add("mini-cart-empty-body");
    document.getElementById("cart-need-little-more").classList.add("none");
  }
  document.getElementById("cart-tray-header-text").innerText = cartHeader;
  document.getElementById("cart-tray-body").innerHTML = cartContainer;
  document.getElementById("mini-cart-footer-contents").innerHTML = cartFooter;
  document.getElementById("cart-tray-note").innerHTML = cartMixNote;
  document
    .getElementById("cart-tray-body")
    .classList.toggle("bg-core-liteCream", cart.item_count === 0);
  document
    .getElementById("mini-cart-footer-contents")
    .classList.toggle("py-8", cart.item_count === 0);
  if (window.Klarna) {
    updateKlarnaInCart(cart.items_subtotal_price);
  }

  // If we're using Storefront API, swap the checkout buttons.
  if (cartPage) {
    const checkoutButton = cartPage.querySelector(".init-checkout");
    const storefrontCheckoutButton = cartPage.querySelector(
      "#storefront-cart-button",
    );
    if (checkoutButton) {
      checkoutButton.classList.add("hidden");
      storefrontCheckoutButton.classList.remove("hidden");
    }
  }
  reloadCartFunctions();
};
window.buildMiniCart = buildMiniCart;

// ADD TO CART – ARRAY OF OBJECTS WITH EACH CONTAINING ITEM ID AND QUANTITY
const addToCart = (array, button) => {
  const addToCartButton = button;
  const errorContainer = document.querySelector(".atc-error-message-container");
  const errorMessage = document.querySelector("#atc-error-message");
  const buttonHTML = addToCartButton.innerHTML;
  const isSwatchCarousel = addToCartButton?.dataset?.location?.includes(
    "utm swatch carousel",
  );
  addToCartButton.innerHTML = "Adding &hellip;";

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(array),
  })
    .then(async (res) => {
      let json = {};

      if (
        res.headers.get("content-type")?.includes("json") ||
        res.headers.get("content-type")?.includes("javascript")
      ) {
        json = await res.json();
      }

      if (!res.ok) {
        if (errorContainer) {
          errorMessage.innerText = json.message;
          errorContainer.classList.remove("hidden");
          addToCartButton.innerText = "Error. Try again!";
          setTimeout(() => {
            addToCartButton.innerText = "Add to Bag";
          }, 2500);
        }
        throw new Error(json.message || res.statusText || res.status);
      }
      return json;
    })
    .then((response) => {
      if (errorContainer && !errorContainer.classList.contains("hidden")) {
        errorContainer.classList.add("hidden");
      }
      let innerText = "Add to Bag";
      if (
        array.items[0].properties &&
        ("PREORDER" in array.items[0].properties ||
          "_PREORDER" in array.items[0].properties)
      ) {
        innerText = "Add to Bag";
      } else if (isSwatchCarousel) {
        innerText = buttonHTML;
      }

      if (addToCartButton.classList.contains("add-color-swatch")) {
        innerText = "GET COLOR SWATCH";
      }
      if (addToCartButton.id && addToCartButton.id == "personalization-atc") {
        closePersonalizationModal();
      }
      setTimeout(() => {
        addToCartButton.innerHTML = innerText;
      }, 500);

      let klaviyoProduct = null;
      if (addToCartButton.classList.contains("quick-atc")) {
        const { dataset } = addToCartButton;
        klaviyoProduct = {
          Name: dataset.atcName,
          ProductID: dataset.atcProductid,
          Categories: dataset.atcCategories,
          ImageURL: dataset.atcImageurl,
          URL: dataset.atcUrl,
          Brand: dataset.atcBrand,
          Price: dataset.atcPrice,
          CompareAtPrice: dataset.atcCompareatprice,
          QuickATC: true,
        };
      }
      addToCartButton.dispatchEvent(cartChangeEvent);
      window.dispatchEvent(
        new CustomEvent(eventNames.ADD_ITEM, {
          detail: {
            data: {
              addToCartResponse: response,
              klaviyoProduct,
            },
            action: "add",
            source: addToCartButton,
          },
        }),
      );
    })
    .catch((error) => {
      console.error(error);
    });
};

// TIMEOUT FUNCTION
const timeout = (tasks, time) => {
  setTimeout(tasks, time);
};

// OPEN MOBILE MENU
const openMenu = (e) => {
  const button = e.currentTarget;
  if (button.classList.contains("active-menu-button")) {
    // CLOSE MENU
    button.classList.remove("active-menu-button");
    document.querySelector(".df-block").classList.remove("show-menu");
    setTimeout(() => {
      document.querySelector(".df-block").classList.remove("visible");
    }, 360);
  } else {
    // OPEN MENU
    document.querySelector(".df-block").classList.add("visible");
    button.classList.add("active-menu-button");
    document.querySelector(".df-block").classList.add("show-menu");
  }
};

if (document.getElementById("mobile-menu-icon")) {
  document
    .getElementById("mobile-menu-icon")
    .addEventListener("click", openMenu);
  document
    .getElementById("mobile-menu-icon")
    .addEventListener("keydown", enterEvent);
}

// ADA Function — Creates a focus trap on modals
window.toTrap;
window.focusReturn = document.querySelector("body");

window.focusTrap = (e) => {
  // Check if the key pressed is the Tab key
  if (e.key !== "Tab" && e.keyCode !== 9) return; // If not, exit

  // Get all focusable elements inside the toTrap element
  const focusable = Array.from(
    toTrap.querySelectorAll(
      "input, button, select, textarea, a, .accessibility-ui, *[tabindex]",
    ),
  );
  // If there are no focusable elements, exit
  if (!focusable.length) return;

  // Get the first and last focusable elements
  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  // Check if shift key is pressed
  const shift = e.shiftKey;
  // If shift key is pressed, handle focus for the first element
  if (
    shift
      ? e.target === first
      : e.target === last || focusable.indexOf(e.target) < 0
  ) {
    // Prevent the default tab behavior
    e.preventDefault();
    // Focus on the appropriate element based on shift key
    (shift ? last : first).focus();
  }
};

let currentlyOpenedMenu;

const checkTabInMenu = (e) => {
  if (e.keyCode === 9) {
    if (
      currentlyOpenedMenu == e.target ||
      currentlyOpenedMenu.contains(e.target)
    ) {
      // DO NOTHING
    } else {
      currentlyOpenedMenu.classList.remove("open-menu");
      currentlyOpenedMenu
        .querySelector(".menu-dropdown")
        .setAttribute("aria-hidden", "true");
      currentlyOpenedMenu.setAttribute("aria-expanded", "false");
      document
        .querySelector("body")
        .removeEventListener("keyup", checkTabInMenu);
    }
  }
};

const expandMenu = (e) => {
  if (e.keyCode === 13) {
    const currentMenu = e.currentTarget;
    if (currentMenu.classList.contains("open-menu")) {
      currentlyOpenedMenu = null;
      currentMenu.classList.remove("open-menu");
      currentMenu.querySelector(".tab-heading").click();
      currentMenu
        .querySelector(".menu-dropdown")
        .setAttribute("aria-hidden", "true");
      currentMenu.setAttribute("aria-expanded", "false");
      document
        .querySelector("body")
        .removeEventListener("keyup", checkTabInMenu);
    } else {
      currentlyOpenedMenu = currentMenu;
      currentMenu.classList.add("open-menu");
      currentMenu.querySelector(".tab-heading").click();
      currentMenu
        .querySelector(".menu-dropdown")
        .setAttribute("aria-hidden", "false");
      currentMenu.setAttribute("aria-expanded", "true");
      document.querySelector("body").addEventListener("keyup", checkTabInMenu);
    }
  }
};

const preventClick = (e) => {
  if (e.target.classList.contains("menu-item")) {
    e.preventDefault();
    const currentMenu = e.currentTarget;
    if (currentMenu.classList.contains("open-menu")) {
      currentlyOpenedMenu = null;
      currentMenu.classList.remove("open-menu");
      currentMenu
        .querySelector(".menu-dropdown")
        .setAttribute("aria-hidden", "true");
      currentMenu.setAttribute("aria-expanded", "false");
      document
        .querySelector("body")
        .removeEventListener("keyup", checkTabInMenu);
    } else {
      currentlyOpenedMenu = currentMenu;
      currentMenu.classList.add("open-menu");
      currentMenu
        .querySelector(".menu-dropdown")
        .setAttribute("aria-hidden", "false");
      currentMenu.setAttribute("aria-expanded", "true");
      document.querySelector("body").addEventListener("keyup", checkTabInMenu);
    }
  }
};

document.querySelectorAll(".menu-item").forEach((button) => {
  button.addEventListener("click", preventClick);
});

document.querySelectorAll(".menu-item").forEach((button) => {
  button.addEventListener("keyup", expandMenu);
});

/**
 * Intentionally using window object so its global.
 */

// FUNCTION TO OPEN A DRAWER
const openDrawer = (e) => {
  /**
   * Set the global variable as our OPEN_CART listener will need to read this value
   */
  window.__cartIsOpen = true;
  const getPageType = () => {
    if (window.location.pathname.includes("/products")) {
      return "product";
    }

    if (window.location.pathname.includes("/collections")) {
      return "collection";
    }

    if (window.location.pathname.includes("/pages")) {
      return "page";
    }

    if (window.location.pathname === "/") {
      return "home";
    }

    return "unknown";
  };
  const getUpsellItems = () => {
    const carousel = document.getElementById("mini-cart-upsell-carousel");
    const items = carousel.querySelectorAll(".carousel-item");

    const upsells = [];

    items.forEach((item) => {
      const upsellImage = item.querySelector("img");
      const upsellTitle = upsellImage.getAttribute("alt");
      const upsellLinkEl = item.querySelector("a");
      const upsellLink = upsellLinkEl.getAttribute("href");

      upsells.push({ upsell: upsellTitle, upsell_link: upsellLink });
    });

    return upsells;
  };

  trackMiniCartClick("opened");
  trackMiniCartView(
    window.cart.total_price / 100,
    window.cart.items,
    getPageType(),
    getUpsellItems(),
  );
  // NEED TO ADD ACCESSIBILITY FUNCTIONS
  document.querySelector("body").classList.add("open-cart-drawer");
  let drawer;
  const cookieWrapper = document.getElementById("cookie-privs");
  if (e.currentTarget) {
    drawer = document.getElementById(e.currentTarget.dataset.drawer);
    if (!drawer.classList.contains(`open-drawer`)) {
      window.focusReturn = e.currentTarget;
    }
  } else {
    drawer = document.getElementById(e);
  }
  if (drawer.classList.contains(`open-drawer`)) {
    window.removeEventListener("keydown", focusTrap);
    drawer.classList.remove(`open-drawer`);
    document
      .getElementById("website-content")
      .setAttribute("aria-hidden", "false");
    document.querySelector("body").removeEventListener("click", closeCart);
    focusReturn.focus();
    drawer.classList.add("invisible");
    drawer.setAttribute("aria-hidden", "true");
    drawer.setAttribute("aria-modal", "false");
  } else {
    toTrap = drawer;
    drawer.classList.add(`open-drawer`);
    drawer.setAttribute("aria-hidden", "false");
    drawer.setAttribute("aria-modal", "true");
    drawer.classList.remove("invisible");
    drawer.focus();
    if (cookieWrapper) {
      cookieWrapper.setAttribute("aria-hidden", "true");
    }
    document
      .getElementById("website-content")
      ?.setAttribute("aria-hidden", "true");

    window.addEventListener("keydown", focusTrap);
  }
};

// FUNCTION TO CLOSE THE CART
const closeCart = (e) => {
  /**
   * Set the global variable as our OPEN_CART listener will need to read this value
   */
  window.__cartIsOpen = false;
  trackMiniCartClick("closed");
  const tray = document.getElementById("cart-tray-widget");
  if (
    (!e.target.classList.contains("cart-button") &&
      !e.target.classList.contains("cart-tray-widget") &&
      !tray.contains(e.target)) ||
    e.currentTarget.classList.contains("close-cart-tray")
  ) {
    document.querySelector("body").classList.remove("open-cart-drawer");
    document.getElementById("cart-tray-widget").classList.remove("open-drawer");
    document
      .getElementById("website-content")
      ?.setAttribute("aria-hidden", "false");
    document.querySelector("body").removeEventListener("click", closeCart);
    window.removeEventListener("keydown", focusTrap);
    focusReturn.focus();
    document
      .getElementById("cart-tray-widget")
      .setAttribute("aria-modal", "false");
    document
      .getElementById("cart-tray-widget")
      .setAttribute("aria-hidden", "true");
  }
};

// ADD EVENT LISTENERS TO CART BUTTON
document.getElementById("cart-button").addEventListener("click", openDrawer);
document.getElementById("cart-button").addEventListener("keydown", enterEvent);
document.getElementById("close-cart-tray").addEventListener("click", closeCart);
document
  .getElementById("close-cart-tray")
  .addEventListener("keydown", enterEvent);

document.body.addEventListener("click", (e) => {
  const cart = document.querySelector(".cart-tray-container");
  const cartButton = document.querySelector(".cart-button");

  const isCartRelated =
    cart.contains(e.target) || cartButton.contains(e.target);

  if (window.__cartIsOpen && !isCartRelated) {
    closeCart(e);
  }
});

// FUNCTION TO OPEN AND CLOSE ACCOUNT PAGE TABS
const toggleTab = (e) => {
  const heading = e.currentTarget;
  const container = heading.nextElementSibling;
  if (container.classList.contains("open-tab")) {
    container.classList.remove("open-tab");
    container.classList.remove("visible");
    heading.querySelector(".tab-icon").innerText = `+`;
    container.setAttribute("aria-hidden", "true");
  } else {
    container.classList.add("open-tab");
    container.classList.add("visible");
    heading.querySelector(".tab-icon").innerText = `–`;
    container.setAttribute("aria-hidden", "false");
  }
};

// ADD EVENT LISTENERS TO TABS TO USE toggleTab FUNCTION
document.querySelectorAll(".tab-heading").forEach((heading) => {
  heading.addEventListener("click", toggleTab);
  heading.addEventListener("keydown", enterEvent);
});

// ADD EVENT LISTENERS FOR TABS ON TABLET SIZED DEVICES
const tabletTabs = document.querySelectorAll(".tablet-flex.tab-heading");
if (tabletTabs) {
  tabletTabs.forEach((heading) => {
    heading.removeEventListener("click", toggleTab);
    heading.addEventListener("click", (e) => {
      tabletTabs.forEach((tab) => {
        if (tab != e.currentTarget) {
          const container = tab.nextElementSibling;
          container.classList.remove("open-tab");
          container.classList.remove("visible");
          tab.querySelector(".tab-icon").innerText = `+`;
          container.setAttribute("aria-hidden", "true");
        } else {
          toggleTab(e);
        }
      });
    });
  });
}

const stampedKey = "pubkey-811l536uX1H0TW9mkl620Bg9718PlA";

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const shortMonths = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "June",
  "July",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];

const getReviews = (productId, widgetKey) =>
  new Promise((resolve) => {
    const url = `https://stamped.io/api/widget/reviews?productId=${productId}&minRating=1&take=100&storeUrl=birdygrace.myshopify.com&apiKey=${widgetKey}`;
    const options = {
      method: "GET",
    };

    fetch(url, options)
      .then((res) => res.json())
      .then((json) => {
        const data = json;
        const reviews = { reviews: [], images: [] };
        reviews.total = data.total;
        reviews.average = data.rating;
        data.data.forEach((review, index) => {
          let info = {};
          if (review.reviewOptionsList && review.reviewOptionsList.length > 0) {
            for (const key in review.reviewOptionsList) {
              info[`${review.reviewOptionsList[key].message.trim()}`] =
                review.reviewOptionsList[key];
            }
          } else {
            info = null;
          }
          let photos = [];
          if (review.reviewUserPhotos && review.reviewUserPhotos.length > 0) {
            photos = review.reviewUserPhotos.split(",");
          }
          reviews.reviews.push({
            body: review.reviewMessage,
            time: review.reviewDate,
            score: review.reviewRating,
            info,
            user: review.author,
            images: photos,
            title: review.reviewTitle,
            verified: review.reviewVerifiedType,
          });
          if (review.reviewUserPhotos && review.reviewUserPhotos.length > 0) {
            photos.forEach((image) => {
              reviews.images.push({
                image,
                review_index: index,
              });
            });
          }
        });
        resolve(reviews);
      })
      .catch((err) => console.error(`error:${err}`));
  });

sortReviews = (e) => {
  const sorting = e.currentTarget.value;
  const data = allReviews;
  const { reviews } = data;
  const images = [];

  if (sorting == "new") {
    reviews.sort((a, b) => {
      const fa = new Date(a.time);
      const fb = new Date(b.time);
      return fb - fa;
    });
  } else if (sorting == "old") {
    reviews.sort((a, b) => {
      const fa = new Date(a.time);
      const fb = new Date(b.time);
      return fa - fb;
    });
  } else if (sorting == "rating-high") {
    reviews.sort((a, b) => b.score - a.score);
  } else if (sorting == "rating-low") {
    reviews.sort((a, b) => a.score - b.score);
  }

  document.getElementById("reviews-body").innerHTML = ``;
  reviews.forEach((review, index) => {
    review.images.forEach((image) => {
      images.push({
        image,
        review_index: index,
      });
    });
  });
  data.reviews = reviews;
  data.images = images;
  window.allReviews = data;
  initializeReviews(data);
};

// GET CUSTOM GALLERY FROM YOTPO AND RETURN ARRAY OF IMAGES – RESOLVES A PROMISE

window.getCustomGallery = (albumName, productId, widgetKey) =>
  new Promise((resolve) => {
    let url = `https://stamped.io/api/widget/reviews?type=instagram-feed&albumId=${albumName}&productId=${productId}&take=100&apiKey=${stampedKey}&storeUrl=birdygrace.myshopify.com`;
    url = encodeURI(url);
    const options = {
      method: "GET",
      crossDomain: true,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };

    fetch(url, options)
      .then((res) => res.json())
      .then((json) => {
        const arr = [];

        json.data.forEach((image) => {
          arr.push({
            src: image.imageUrl,
            caption: image.mediaText,
            products: image.tags,
            user: image.username,
            timestamp: image.dateCreated,
          });
        });

        resolve(arr);
      })
      .catch((err) => {
        console.error(`error:${err}`);
        resolve({ error: "There was an error fetching the instagram results" });
      });
  });

// BUILDS A MODAL GIVEN HTML CONTENT

window.buildModal = (content) => {
  const timestamp = Date.now();
  const modal = `
    <div role="dialog" aria-hidden="false" aria-modal="true" tabindex="0" id="modal-${timestamp}" class="modal fixed flex w-screen h-screen z-[2147483643] bg-paleBlush/50 items-center justify-center">
    <div class="modal-inner relative custom-scrollbar">
    <div aria-label="Close modal" role="button" tabindex="0" id="close-${timestamp}" class="absolute bg-white modal-close cursor-pointer z3 accessibility-ui top-4 right-4 text-[2rem] z-10 rounded-[50%] size-8 grid items-center justify-center leading-[0.2] pb-0.5" data-modal="${timestamp}">
    &times;
    </div>
    ${content}
    </div>
    <div role="button" tabindex="0" aria-label="Blank element to solve scripting limitation"></div>
    </div>
  `;
  document.querySelector("body").insertAdjacentHTML("afterbegin", modal);
  document
    .getElementById(`close-${timestamp}`)
    .addEventListener("click", closeModal);
  document
    .getElementById(`close-${timestamp}`)
    .addEventListener("keydown", enterEvent);
  document.querySelectorAll(".modal-insta-product").forEach((thumb) => {
    thumb.addEventListener("click", swapInstaProduct);
    thumb.addEventListener("keydown", enterEvent);
  });

  document.querySelectorAll(".advance-insta").forEach((button) => {
    button.addEventListener("click", nextInstaImage);
    button.addEventListener("keydown", enterEvent);
  });

  document.querySelectorAll(".cookie-settings-consent").forEach((button) => {
    button.addEventListener("click", hideCookieBanner);
    button.addEventListener("keydown", enterEvent);
  });

  document
    .querySelector(".modal")
    .querySelectorAll(".standard-tab-label")
    .forEach((label) => {
      label.addEventListener("click", toggleTitle);
      label.addEventListener("keydown", enterEvent);
    });

  document.getElementById(`modal-${timestamp}`).focus();
  document
    .getElementById("website-content")
    .setAttribute("aria-hidden", "true");
  window.toTrap = document.getElementById(`modal-${timestamp}`);
  window.addEventListener("keydown", focusTrap);
};

// FUNCTION TO CLOSE A MODAL
const closeModal = (e) => {
  const id = e.currentTarget.dataset.modal;
  if (id) {
    const modal = document.getElementById(`modal-${id}`);
    if (modal) {
      modal.remove();
      document.querySelector("body").removeEventListener("click", closeModal);
      document
        .getElementById("website-content")
        .setAttribute("aria-hidden", "false");
      focusReturn.focus();
    }
  } else {
    const item = e.target;
    const mode = document.querySelector(".modal-inner");
    if (mode) {
      if (
        item.classList.contains("modal-inner") == false &&
        mode.contains(item) == false
      ) {
        document.querySelectorAll(".modal").forEach((modal) => {
          modal.remove();
        });
        document
          .getElementById("website-content")
          .setAttribute("aria-hidden", "false");
        focusReturn.focus();
      }
    }

    document
      .getElementById("website-content")
      .setAttribute("aria-hidden", "false");
    focusReturn.focus();

    document.querySelector("body").removeEventListener("click", closeModal);
  }
};

const nextInstaImage = (e) => {
  const post = e.currentTarget.dataset.adv;
  const modal = document.querySelector(".modal");
  if (modal && post) {
    modal.remove();
    document.querySelector("body").removeEventListener("click", closeModal);
    const show = document.getElementById(post);
    if (show && e.currentTarget.classList.contains("review-carousel-adv")) {
      reviewImageModal(show);
    } else {
      showInsta(post);
    }
  }
};

const swapInstaProduct = (e) => {
  const toSwap = e.currentTarget;
  const container = document.getElementById("active-insta-product");

  const contents = `<div class="grid gap-4 items-center grid-cols-instaGrid">
    <div class="active-insta-product-wrapper" data-url="${
      toSwap.dataset.url
    }"><img src="${toSwap.dataset.image}" loading="lazy"></div>
    <div class="uppercase h-max"><div class="font-semibold lh125">${
      toSwap.dataset.name.split("-")[0]
    }</div>
    <div class="lh125">${toSwap.dataset.name.split("-")[1]}</div>
    <br>
    <a class="no-underline" href="${toSwap.dataset.url}"><button class="button button-primary">SHOP NOW</button></a>
    </div>
    </div>`;
  container.innerHTML = contents;
  document.querySelectorAll(".selected-insta-product").forEach((item) => {
    item.classList.remove("selected-insta-product");
  });
  toSwap.classList.add("selected-insta-product");

  if (window.location.href.indexOf("products") !== -1) {
    document
      .querySelectorAll(".active-insta-product-wrapper")
      .forEach((modalProduct) => {
        getImageForInstaProducts(
          modalProduct,
          modalProduct.dataset.url,
          122,
          182,
        );
      });
  }
};

// FUNCTION TO BUILD INSTAGRAM FEED FOR THE HOMEPAGE
if (document.getElementById("home-instagram")) {
  const container = document.getElementById("home-instagram");
  getCustomGallery(
    container.dataset.gallery,
    container.dataset.product,
    stampedKey,
  ).then((data) => {
    let elements = ``;
    data.forEach((item, index) => {
      if (index < 10) {
        let prev = `null`;
        let next = `null`;

        if (index !== 0) {
          prev = `home-insta-object-${index - 1}`;
        }

        if (index < 9 && index !== data.length - 1) {
          next = `home-insta-object-${index + 1}`;
        }

        elements += `
      <button class="insta-image cursor-pointer carousel-item flex snap-start insta-image-${index} relative bg-transparent border-0 p-0" data-prev="${prev}" data-next="${next}" data-timestamp="${item.timestamp}" data-image="${item.src}" data-caption="${item.caption}" data-products='${JSON.stringify(item.products)}' data-hashtags='${JSON.stringify(item.hashtags)}' data-user="${item.user}" data-profilepic="${item.profile_pic}" data-index="${index}" id="home-insta-object-${index}" aria-focusable="true">
        <picture>
          <img alt="${item.caption}" height="500" width="500" loading="lazy" class="max-w-sm max-h-sm min-w-56 min-h-56 w-96 h-96 object-cover" src="${item.src}" />
        </picture>
      </button>
    `;
      }
    });
    elements += `<div class="more-insta carousel-item flex snap-start">
      <a class="no-underline" href="/pages/real-weddings">
        <div class="max-w-sm max-h-sm min-w-56 min-h-56 w-96 h-96 flex items-center bg-core-liteCream">
          <div class="h4 p-4 w-full text-center">See more real weddings</div>
        </div>
      </a>
    </div>
    `;
    container.innerHTML = elements;
    document.querySelectorAll(".insta-image").forEach((insta) => {
      insta.addEventListener("click", showInsta);
      insta.addEventListener("keydown", enterEvent);
    });
  });
}

// FUNCTION TO CREATE A MODAL FOR AN INSTAGRAM POST

const showInsta = (e) => {
  let post;

  if (e.currentTarget) {
    post = e.currentTarget;
    window.focusReturn = e.currentTarget;
  } else {
    post = document.getElementById(e);
    window.focusReturn = document.getElementById(e);
  }

  const products = JSON.parse(post.dataset.products);
  let productContainer = ``;
  if (products.length > 0) {
    productContainer += `<div id="active-insta-product"><div class="grid gap-4 items-center grid-cols-instaGrid">

<div class="active-insta-product-wrapper" data-url="${
      products[0].productUrl
    }"><img src="${products[0].imageUrl}" loading="lazy"></div>
<div class="uppercase h-max"><div class="font-semibold lh125">${
      products[0].title.split("-")[0]
    }</div>
<div class="lh125">${products[0].title.split("-")[1]}</div>
<br>
<a class="no-underline" href="${products[0].productUrl}"><button class="button button-primary">SHOP NOW</button></a>
</div>
</div></div>
`;
    if (products.length > 1) {
      productContainer += `<br><div class="font-semibold">OTHER TAGGED PRODUCTS</div><br><div class="grid gap-4 insta-modal-product-grid">`;
      const usedProducts = [];
      products.forEach((product, index) => {
        const pic = new Image();
        pic.src = product.imageUrl;
        if (!usedProducts.includes(product.title)) {
          if (index == 0) {
            productContainer += `<div class="selected-insta-product modal-insta-product cursor-pointer" data-name="${product.title}" data-url="${product.productUrl}" data-image="${product.imageUrl}">
<img src="${product.imageUrl}" height="120" width="80" loading="lazy"></div>
`;
          } else {
            productContainer += `<div class="modal-insta-product cursor-pointer" data-name="${product.title}" data-url="${product.productUrl}" data-image="${product.imageUrl}">
<img src="${product.imageUrl}" height="120" width="80" loading="lazy"></div>
`;
          }
          usedProducts.push(product.title);
        }
      });
      productContainer += `</div>`;
    }
    productContainer += `<br>`;
  }
  const time = new Date(
    post.dataset.timestamp
      .substring(0, post.dataset.timestamp.indexOf("T"))
      .replace(/-/g, "/"),
  );
  const day = `0${time.getDate()}`.slice(-2);
  const month = `0${time.getMonth() + 1}`.slice(-2);
  const year = time.getFullYear().toString().slice(-2);
  const postPic = new Image();
  postPic.src = post.dataset.image;

  let moveLeft = ``;
  let moveRight = ``;

  if (post.dataset.prev !== "null") {
    moveLeft = `<div class="cursor-pointer absolute bg-white insta-left advance-insta flex items-center justify-center left-4" data-adv="${post.dataset.prev}">
<svg class="w-4" viewBox="0 0 10.79 18">
<g transform="translate(3 9) rotate(90)">
  <g>
    <g transform="translate(-8.316 -4)">
      <line id="Line_290" class="caret" x1="1.59" y1="-0.45" x2="9" y2="5.66"/>
      <line id="Line_291" class="caret" x1="16.41" y1="-0.45" x2="9" y2="5.66"/>
    </g>
  </g>
</g>
</svg>
</div>`;
  }

  if (post.dataset.next !== "null") {
    moveRight = `<div class="cursor-pointer absolute bg-white insta-right advance-insta flex items-center justify-center right-4" data-adv="${post.dataset.next}">
<svg class="w-4" viewBox="0 0 10.79 18">
<g transform="translate(5 9) rotate(90)">
  <g>
    <g transform="translate(-8.316 -4)">
      <line id="Line_290" class="caret" x1="9" y1="-0.45" x2="1.59" y2="5.66"/>
      <line id="Line_291" class="caret" x1="9" y1="-0.45" x2="16.41" y2="5.66"/>
    </g>
  </g>
</g>
</svg>
</div>`;
  }

  const modalContent = `
<div class="grid md:grid-cols-2 gap-4 h-full">
<div class="relative flex items-center h-full">
<div class="relative">
<img class="insta-social-photo w-full" height="500" width="500" src="${post.dataset.image}" loading="lazy">
${moveLeft}
${moveRight}
</div>
</div>
<div class="py-8 px-4">
<div>
${productContainer}
<hr class="text-brand-deepMocha-50 border-solid border-t-2 border-b-0">
<div class="flex justify-between mt-4">
<div class="font-semibold">${post.dataset.user}</div>
<div class="font-semibold text-sm md:text-base">${month}/${day}/${year}</div>
</div>
<p class="top1">${post.dataset.caption}</p>
</div>

</div>
</div>
`;
  setTimeout(() => {
    document
      .querySelectorAll(".modal-insta-product")
      .forEach((modalProduct) => {
        getImageForInstaProducts(
          modalProduct,
          modalProduct.dataset.url,
          80,
          120,
        );
      });

    document
      .querySelectorAll(".active-insta-product-wrapper")
      .forEach((modalProduct) => {
        getImageForInstaProducts(
          modalProduct,
          modalProduct.dataset.url,
          122,
          182,
        );
      });
  }, 100);

  return buildModal(modalContent);
};

function getImageForInstaProducts(element, productUrl, width, height) {
  const elementImage = element.querySelector("img");
  const ImageNotLoaded = elementImage.naturalWidth === 0;
  if (ImageNotLoaded) {
    fetch(
      `${
        window.Shopify.routes.root +
        productUrl.substring(productUrl.indexOf("products"))
      }.js`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
    )
      .then((res) => res.json())
      .then((response) => {
        element
          .querySelector("img")
          .setAttribute(
            "src",
            `${response.featured_image}?width=${width}&height=${height}`,
          );
      });
  }
}

// FUNCTION TO MOVE A CAROUSEL GIVEN A DIRECTION AND CAROUSEL ID
const moveCarousel = (e) => {
  const button = e.currentTarget;
  const { direction } = button.dataset;
  const section = button.closest(".shopify-section");
  let carousel;

  if (document.getElementById(button.dataset.item)) {
    carousel = section.querySelector(`[id="${button.dataset.item}"]`);
  } else {
    carousel = document.getElementsByClassName(button.dataset.item)[0];
  }

  const carouselWidth = carousel.offsetWidth;
  const position = carousel.scrollLeft;
  const scrollAmt = (carouselWidth * 3) / 4;
  let destination = position + scrollAmt;
  if (direction == "left") {
    destination = position - scrollAmt;
  }
  let final = 0;
  carousel.querySelectorAll(".carousel-item").forEach((item) => {
    const currentFinal = Math.abs(final - destination);
    const currentPosition = Math.abs(item.offsetLeft - destination);
    if (currentPosition < currentFinal) {
      final = item.offsetLeft;
    }
  });
  if (!scrollBehavior) {
    carousel.style.scrollSnapType = "none";
    setTimeout(() => {
      carousel.style.scrollSnapType = "x mandatory";
    }, 400);
  }
  carousel.scrollTo({
    top: 0,
    left: final,
    behavior: "smooth",
  });

  // If carousel expands to the width of the screen, we can toggle on and off the arrows opacity so users know they're at the end or beginning of carousel.
  section
    .querySelector(".carousel-left")
    .classList.toggle("opacity-50", final === 0);
  section
    .querySelector(".carousel-right")
    .classList.toggle("opacity-50", final === carouselWidth);
};

const moveProductCarousel = (e) => {
  const button = e.currentTarget;
  const { direction } = button.dataset;
  const carousel = document.querySelector(".product-image-container");
  const carouselHeight = carousel.offsetHeight;
  const position = carousel.scrollTop;
  const scrollAmt = (carouselHeight * 3) / 4;
  let destination = carousel.scrollTop + scrollAmt;
  if (direction == "up") {
    destination = carousel.scrollTop - scrollAmt;
  }
  let final = 0;
  carousel.querySelectorAll(".pdp-thumb").forEach((item) => {
    const currentFinal = Math.abs(final - destination);
    const currentPosition = Math.abs(item.offsetTop - destination);
    if (currentPosition < currentFinal) {
      final = item.offsetTop;
    }
  });
  carousel.scrollTo({
    top: final,
    left: 0,
    behavior: "smooth",
  });
};

// ADD EVENT LISTENER FOR moveCarousel TO EACH ELEMENT WITH THE carousel-button CLASS
document.querySelectorAll(".carousel-button").forEach((button) => {
  button.addEventListener("click", moveCarousel);
  button.addEventListener("keydown", enterEvent);
});

document.querySelectorAll(".product-image-button").forEach((button) => {
  button.addEventListener("click", moveProductCarousel);
  button.addEventListener("keydown", enterEvent);
});

// FUNCTION FOR VERIFYING INPUT
const verifyInput = (input) => {
  let verified;
  if (input.classList.contains("personalizer")) {
    if (input.value.trim().length > 0) {
      verified = true;
      input.classList.remove("invalid-input");
      document.getElementById("personalizer-input")?.classList.add("exists");
      document
        .getElementById("personalizer-input")
        ?.setAttribute("aria-describedby", "");
      input.placeholder = "";
      const personalizeAtc = document.getElementById("personalization-atc");
      if (
        personalizeAtc &&
        personalizeAtc.innerText == "PLEASE FIX THE ERROR"
      ) {
        personalizeAtc.innerText = "Add to Bag";
      }
    } else {
      verified = false;
    }
  } else if (input.classList.contains("email-input")) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(input.value)) {
      verified = true;
      input.classList.remove("invalid-input");
    } else {
      verified = false;
    }
  } else {
    verified = true;
  }
  if (verified == true) {
    return true;
  }
  return false;
};

function addProductTagsToStorage(handle) {
  if (handle) {
    fetch(`/products/${handle}.js`)
      .then((res) => res.json())
      .then((product) => {
        localStorage.setItem(`${product.id}`, `${product.tags}`);
      });
  }
}

// Storefront API helper function. Adjust items with cart line attributes with adding to cart.
const editItemBeforeAdd = (itemId, option) => {
  const id = `gid://shopify/ProductVariant/${itemId}`;
  const body = { lines: [] };
  const entry = { quantity: 1, merchandiseId: id, attributes: [] };

  if (option.dataset.madetoorder) {
    entry.attributes.push({
      key: "_MADE-TO-ORDER",
      value: `Expected to arrive between ${option.dataset.madetoorder}`,
    });
    if (option.dataset.productiondays) {
      entry.attributes.push({
        key: "_PRODUCTION_DAYS",
        value: option.dataset.productiondays,
      });
    }
    entry.attributes.push({
      key: "_PROMISED_BY_DATE",
      value: `${option.dataset.madetoorder}`,
    });
  }

  if (option.dataset.readytoship) {
    let readyToShipMessage = `Expected to deliver in ~${option.dataset.readytoship} business days`;
    if (option.dataset.giftcard) readyToShipMessage = option.dataset.giftcard;

    entry.attributes.push({
      key: "_READY-TO-SHIP",
      value: readyToShipMessage,
    });
  }

  if (option.dataset.giftcard) {
    entry.attributes.push({
      key: "_GIFT_CARD",
      value: option.dataset.giftcard,
    });
  }

  if (!option.dataset.madetoorder) {
    if (option.dataset.preorder) {
      entry.attributes.push({
        key: "_PREORDER",
        value: `Expected to deliver by ${option.dataset.preorder}`,
      });
    }
  }
  if (option.dataset.preorderdate) {
    entry.attributes.push({
      key: "_preorderdate",
      value: option.dataset.preorderdate,
    });
  }
  if (option.dataset.finalSale && option.dataset.finalSale === "true") {
    entry.attributes.push({
      key: "is_final_sale",
      value: option.dataset.finalSale,
    });
  }
  // Quick Add Attributes
  if (option.dataset.location) {
    entry.attributes.push({ key: "_location", value: option.dataset.location });
    entry.attributes.push({ key: "_type", value: option.dataset.quicktype });
  }
  if (option.dataset.quickswatch) {
    entry.attributes.push({
      key: "_QUICK_SWATCH",
      value: "true",
    });
  }
  if (option.dataset.readytoship) {
    entry.attributes.push({
      key: "_READY-TO-SHIP",
      value: `Expected to deliver in ~${option.dataset.readytoship} business days`,
    });
  }
  if (option.dataset.preorder) {
    entry.attributes.push({
      key: "_PREORDER",
      value: `Expected to deliver by ${option.dataset.preorder}`,
    });
  }

  document.querySelectorAll(".line-prop-input").forEach((property) => {
    if (!property.disabled) {
      entry.attributes.push({
        key: property.dataset.key,
        value: property.value,
      });
    }
  });

  document.querySelectorAll(".line-prop-radio").forEach((radio) => {
    if (!radio.disabled && radio.checked) {
      if (radio.dataset.key == "CustomizationPlacement") {
        placement = radio.value;
      }
      entry.attributes.push({
        key: radio.dataset.key,
        value: radio.value,
      });

      if (radio.dataset.sizekey) {
        const size = radio.dataset.currentsize;
        entry.attributes.push({
          key: radio.dataset.sizekey,
          value: size,
        });
      }
    }
  });
  body.lines.push(entry);
  return body;
};

window.atcClick = async (e) => {
  const button = e.currentTarget;
  let isSizeSelected = false;
  let isVariantSelected = false;
  const variationRadios = document.querySelectorAll(".slit-variation-radio");
  const addToCartWrapper = document.querySelector(".pdp-ctas");
  const sizeDropdown = document.querySelector(".size-dropdown");
  const sizeAndLengthDropdowns = document.querySelectorAll(
    ".size-dropdown, .length-dropdown",
  );
  error = document.querySelector(".option-not-selected");

  e.preventDefault();
  window.focusReturn = button;

  if (e.target.getAttribute("id") === "pdp-atc") {
    if (sizeDropdown && sizeDropdown.getAttribute("value")) {
      isSizeSelected = true;
    }
    variationRadios.forEach((radio) => {
      if (radio.checked) {
        isVariantSelected = true;
      }
    });
    if (
      sizeDropdown &&
      !isSizeSelected &&
      variationRadios.length &&
      !isVariantSelected
    ) {
      error?.remove();
      sizeDropdown.removeAttribute("aria-live");
      addToCartWrapper.insertAdjacentHTML(
        "afterbegin",
        `<p id="size-variant-not-selected" aria-live="assertive" role="alert" class="option-not-selected uppercase text-base text-brand-errorText font-semibold mt-0">Please select size & variation</p>`,
      );
      return false;
    }
    if (variationRadios.length && !isVariantSelected) {
      error?.remove();
      sizeDropdown.removeAttribute("aria-live");
      addToCartWrapper.insertAdjacentHTML(
        "afterbegin",
        `
      <p id="variant-not-selected" aria-live="assertive" role="alert" class="option-not-selected uppercase text-base text-brand-errorText font-semibold mt-0">Please select variation</p>`,
      );
      return false;
    }
    if (sizeAndLengthDropdowns.length) {
      let dropdownSelected = true;
      let message = "Please select a size to continue.";
      const errorContainer = document.querySelector(
        ".atc-error-message-container",
      );
      const errorMessage = document.querySelector("#atc-error-message");
      sizeAndLengthDropdowns.forEach((dropdown) => {
        if (!dropdown.getAttribute("value")) {
          error?.remove();
          if (dropdown.classList.contains("length-dropdown")) {
            message = "Please select a length to continue.";
          }
          dropdown.classList.add("has-error");
          dropdown.setAttribute("aria-live", "assertive");
          dropdownSelected = false;
        }
      });
      if (errorContainer) {
        errorContainer.classList.toggle("hidden", dropdownSelected);
        errorMessage.innerText = message;
      }
      if (dropdownSelected == false) return true;
    }
  }

  if (button.classList.contains("inactive-atc")) {
    window.location = `/products/${button.dataset.handle}`;
    return;
  }
  if (!button.disabled && !button.classList.contains("bis-cta")) {
    let quickAdd = false;
    if (button.classList.contains("quick-atc")) {
      quickAdd = true;
    }
    if (quickAdd) {
      const toAdd = button.dataset.variantid;
      let body;

      body = editItemBeforeAdd(toAdd, button);
      document.querySelectorAll(".line-prop-input").forEach((property) => {
        if (!property.disabled) {
          const verify = verifyInput(property);
          if (!verify) {
            isVerified = false;
            property.classList.add("invalid-input");
            document.getElementById("personalizer-input")
              ? (document.getElementById("personalizer-input").placeholder =
                  `PLEASE ADD TEXT`)
              : null;
            document
              .getElementById("personalizer-input")
              ?.setAttribute("aria-describedby", "Error, please add text");
          }
        }
      });

      throttleAddToCart(body, button);
    } else {
      let placement = "Standard";
      let body;
      let isVerified = true;
      document.querySelectorAll(".variant-select").forEach((selector) => {
        const option = selector.options[selector.selectedIndex];
        let entry;

        body = editItemBeforeAdd(selector.value, option);
        document.querySelectorAll(".line-prop-input").forEach((property) => {
          if (!property.disabled) {
            const verify = verifyInput(property);
            if (!verify) {
              isVerified = false;
              property.classList.add("invalid-input");
              document.getElementById("personalizer-input")
                ? (document.getElementById("personalizer-input").placeholder =
                    `PLEASE ADD TEXT`)
                : null;
              document
                .getElementById("personalizer-input")
                ?.setAttribute("aria-describedby", "Error, please add text");
            }
          }
        });
      });
      if (isVerified) {
        throttleAddToCart(body, e.currentTarget);
      }
    }
  }
  if (e.currentTarget.classList.contains("bis-cta")) {
    showBackInStockModal(e.currentTarget);
  }
};

// hide error label on radio clicks
document.querySelectorAll(".size-radio").forEach((radio) => {
  radio.addEventListener("click", () => {
    document.getElementById("size-not-selected")?.remove();

    document.querySelectorAll(".slit-variation-radio").forEach((radio) => {
      if (radio.checked) {
        document.getElementById("size-variant-not-selected")?.remove();
      }
    });
  });
});

document.querySelectorAll(".slit-variation-radio").forEach((radio) => {
  radio.addEventListener("click", () => {
    document.getElementById("variant-not-selected")?.remove();
    document.querySelectorAll(".size-radio").forEach((radio) => {
      if (radio.checked) {
        document.getElementById("size-variant-not-selected")?.remove();
      }
    });
  });
});

// FUNCTIONS TO THROTTLE ADD TO CART REQUESTS
function throttle(callback, delay) {
  let shouldWait = false;

  return (...args) => {
    if (shouldWait) return;

    callback(...args);
    shouldWait = true;
    setTimeout(() => {
      shouldWait = false;
    }, delay);
  };
}

document.querySelectorAll(".atc").forEach((button) => {
  button.addEventListener("click", atcClick);
  button.addEventListener("keydown", enterEvent);
});

window.hexToRgb = (hex) => {
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b);

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
};

window.getLuminance = (r, g, b) => {
  const a = [r, g, b].map((v) => {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
  });
  return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
};

const checkDropdown = (e) => {
  if (window.innerWidth > 1024) {
    e.preventDefault();
  }
};

// Swatch PLP Sort By Menu
const toggleSortMenu = (isOpen) => {
  const isMobileSort = window.matchMedia("(max-width: 1023px)").matches;
  const sortByContainer = document.querySelector(".collection--sort-by-filter");
  const closeButton = sortByContainer.querySelector(".close-sort-by");
  const sortByButton = sortByContainer.querySelector(".sort-by-button");
  const dropdownContainer = sortByContainer.querySelector(
    ".dropdown-container",
  );

  dropdownContainer.classList.toggle("dropdown-active", isOpen);
  dropdownContainer
    .querySelectorAll(".dropdown-value")
    .forEach((opt) => (opt.tabIndex = isOpen ? 0 : -1));

  sortByButton.ariaExpanded = isOpen.toString();

  if (isMobileSort) {
    closeButton.classList.toggle("hidden", !isOpen);
    if (isOpen) {
      window.toTrap = dropdownContainer;
      setTimeout(() => closeButton.focus(), 100);
    } else {
      setTimeout(() => sortByButton.focus(), 100);
    }
  } else if (isOpen) {
    window.toTrap = document.querySelector(".dropdown-values-wrapper");
  }

  const eventAction = isOpen ? "addEventListener" : "removeEventListener";
  window[eventAction]("keydown", window.focusTrap);
};

const openSortMenu = () => toggleSortMenu(true);
const closeSortMenu = () => toggleSortMenu(false);

window.sort = {
  openMenu: openSortMenu,
  closeMenu: closeSortMenu,
};

document.querySelectorAll(".select-dropdown").forEach((select) => {
  select.addEventListener("mousedown", checkDropdown);
});

const changeDropdown = (e) => {
  const value = e.currentTarget.dataset.select;
  const parent = e.currentTarget.parentNode.parentNode;
  const selector = parent.previousElementSibling.querySelector("select");
  parent.querySelectorAll("[data-select]").forEach((el) => {
    el.classList.remove("active");
    el.ariaSelected = false;
  });
  e.currentTarget.classList.add("active");
  e.currentTarget.ariaSelected = true;
  selector.querySelectorAll("option").forEach((option) => {
    if (option.value == value) {
      option.selected = true;
      const event = new Event("input", {
        bubbles: true,
        cancelable: true,
      });
      selector.dispatchEvent(event);
    }
  });
  closeSortMenu();
};

document.querySelectorAll(".dropdown-value").forEach((value) => {
  value.addEventListener("click", changeDropdown);
  value.addEventListener("keydown", enterEvent);
});

document.querySelectorAll(".sort-by-button").forEach((value) => {
  value.addEventListener("click", openSortMenu);
});
document.querySelectorAll(".close-sort-by").forEach((value) => {
  value.addEventListener("click", closeSortMenu);
});

const getCartUpsells = (cart) => {
  const showDiscountPriceForSwatches = checkForSwatchBuyer(cart);
  let tagString = `tag:"Checkout Aisle"`;
  const cartIDs = [];
  const cartTypes = [];
  cart.items.forEach((item) => {
    let itemId = "";

    let id = item.id.split("/");
    id = id[id.length - 1];
    itemId = id;
    cartIDs.push(itemId);
    if (!cartTypes.includes(item.product_type)) {
      cartTypes.push(item.product_type);
    }
    if (item.title.includes("Robe") && !cartTypes.includes("Robe")) {
      cartTypes.push("Robe");
    }
    if (item.title.includes("Pajama") && !cartTypes.includes("Pajamas")) {
      cartTypes.push("Pajamas");
    }
  });

  tagString = ``;
  let tagLength = 0;

  const keys = Object.keys(upsellMatrix);
  keys.forEach((key) => {
    if (cartTypes.includes(key)) {
      upsellMatrix[key].forEach((tag) => {
        if (!cartTypes.includes(tag.type)) {
          tagString += `tag:"${tag.tag}"`;
          tagLength += 1;
        }
      });
    }
  });
  // If there is no upsell matrix for the cart types, don't run fetch + use default product cards.
  if (tagString != "") {
    const host = window.location.hostname;
    fetch(
      `https://${host}/search?view=dictionary&type=product&q=${tagString}`,
      {
        method: "GET",
      },
    )
      .then((res) => res.text())
      .then((response) => {
        let upsells = [];
        // Grab products string from response
        let data = response.split("let products = ");
        data = data[1].split("</script>")[0];
        // Remove unwanted characters in the string before parsing
        const sanitizedData = data.replace(/[\n\r\t]/g, "").trim();
        try {
          upsells = JSON.parse(sanitizedData);
        } catch (error) {
          console.error("Error parsing JSON:", error);
        }
        upsells = shuffle(upsells).slice(0, 8);
        let picked = [];
        let ind = 0;
        upsells.forEach((upsell) => {
          if (
            ind < maxUpsells &&
            upsell.available == "true" &&
            !picked.includes(upsell) &&
            !cartIDs.includes(upsell.id)
          ) {
            ind += 1;
            picked.push(upsell);
          }
        });

        picked = shuffle(picked);
        let upsellContainer = ``;
        let cartPageUpsellContainer = ``;

        picked.forEach((upsell) => {
          const finalSale = upsell.tags.some(
            (tag) => tag === "finalsale" || tag === "Final Sale",
          );
          const shipNow = upsell.tags.some(
            (tag) =>
              tag === "ss-temp-ships-now-all-sizes-plp-badge'" ||
              tag === "sstempshipsnowallsizesplpbadge",
          );
          const name = upsell.title.split("-");
          const mainName = name[0];
          const title = `<div>${mainName}</div>`;
          let subtitle = ``;
          if (name.length > 1) {
            let fabric = ``;
            if (upsell.type !== "Swatch") {
              upsells?.tags?.find((tag) => {
                if (tag.toLowerCase().startsWith("fabric:")) {
                  const fabricTag = tag.split("fabric:")[1];
                  fabric = allFabrics
                    .find((fabricMapTag) =>
                      fabricMapTag.toLowerCase().includes(fabricTag),
                    )
                    .trim();
                }
                return fabric;
              });
            }
            subtitle = `<span class="font-normal">${fabric} ${name[1].replace(" in ", " ")}</span>`;
          }

          let button = ``;
          if (upsell.variants.length == 1) {
            button = `<button data-handle="${upsell.variants[0].id}" class="upsell-atc button button-secondary w-full" data-location="mini-cart" data-quicktype="cart upsell" data-final-sale="${finalSale}">ADD TO BAG</button>`;
          } else {
            button = `<a class="no-underline text-center box-border" href="${upsell.url}"><div class="button button-secondary w-full">View</div></a>`;
          }

          const getCardPrice = (salePrice, price, type, showSwatchDiscount) => {
            const hasSalePrice =
              salePrice && Number(price.slice(1)) > Number(salePrice.slice(1));
            const isSwatch = type.includes("Swatch");

            if (isSwatch && showSwatchDiscount) {
              return `<div class="text-brand-darkerMocha line-through decoration-2"><span class="text-brand-deepMocha-75">${upsell.price}</span></div><span>$0</span>`;
            }

            if (hasSalePrice) {
              return `<div class="text-brand-darkerMocha line-through decoration-2"><span class="text-brand-deepMocha-75">${upsell.price}</span></div><span>${upsell.compare_at_price}</span>`;
            }

            return upsell.price;
          };

          const cardPrice = getCardPrice(
            upsell.compare_at_price,
            upsell.price,
            upsell.type,
            showDiscountPriceForSwatches,
          );

          upsellContainer += `
            <div class="carousel-item flex snap-start mb-4 relative">
            ${shipNow ? `<div class="ships-now absolute uppercase">Ships Now in All Sizes</div>` : ``}
            <div class="flex vertical-flex justify-between w-[9rem] md:w-[10.4rem] max-w-[calc(55vw-0.75rem)] md:max-w-[calc(25vw-0.75rem)] h-auto"><a class="no-underline" href="${upsell.url}"><div>
            <img alt="${title.substring(5, title.length - 6)}" width="${upsell.images[0].width}" height="${upsell.images[0].height}" loading="lazy" class="object-cover" src="${upsell.images[0].src.replace("width=1600", "width=200")}">
            <div class="grid text-xs grid-flow-col gap-4 my-1 mx-0 justify-between">
            <div class="upsell-item text-left font-semibold capitalize">${title} ${subtitle}</div>
            <div class="font-semibold">
              ${cardPrice}
            </div>
            </div></div></a>
            ${button}
            </div></div>
            `;
          let pageButton;
          if (upsell.variants.length == 1) {
            pageButton = `<button data-handle="${upsell.variants[0].id}" class="upsell-atc button button-primary w-full" data-location="cart page" data-quicktype="cart upsell" data-final-sale="${finalSale}">Add to Bag</button>`;
          } else {
            pageButton = `<a class="no-underline" href="${upsell.url}"><button class="w-full button button-primary">View Product</button></a>`;
          }

          cartPageUpsellContainer += `
            <div class="carousel-item flex snap-start mb-4">
            <div class="flex vertical-flex justify-between w-[9rem] md:w-[10.4rem] max-w-[calc(55vw-0.75rem)] md:max-w-[calc(25vw-0.75rem)] h-auto"><a class="no-underline" href="${upsell.url}"><div>
            <img alt="${title.substring(5, title.length - 6)}" width="${upsell.images[0].width}" height="${upsell.images[0].height}" loading="lazy" class="object-cover" src="${upsell.images[0].src.replace("width=1600", "width=290&height=290")}">
            <div class="grid text-xs grid-flow-col gap-4 my-1 mx-0 justify-between">
            <div class="text-left font-semibold capitalize">${title} ${subtitle}</div>
            <div class="font-semibold">
              ${cardPrice}
            </div>
            </div>
            </div>
            </a>
            ${pageButton}
            </div>
            </div>
            `;
        });
        document.getElementById("mini-cart-upsell-carousel").innerHTML =
          upsellContainer;
        if (document.getElementById("cart-upsell-carousel")) {
          document.getElementById("cart-upsell-carousel").innerHTML =
            cartPageUpsellContainer;
        }
        document.querySelectorAll(".upsell-atc").forEach((button) => {
          button.addEventListener("click", upsellAtc);
          button.addEventListener("keydown", enterEvent);
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }
};
window.getCartUpsells = getCartUpsells;

// TAB CONTENT

const setTab = (e) => {
  const current = e.currentTarget;
  const parent = e.currentTarget.parentElement;
  parent.querySelectorAll(".tab-label").forEach((label) => {
    label.classList.remove("active-tab-label");
  });
  current.classList.add("active-tab-label");
  const grid = document.getElementById(current.dataset.grid);
  const toShow = current.dataset.item;
  grid.querySelectorAll(".featured-product-grid-item").forEach((i) => {
    if (i.classList.contains(toShow)) {
      i.classList.remove("none");
    } else {
      i.classList.add("none");
    }
  });
  grid.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
};

document.querySelectorAll(".tab-label").forEach((label) => {
  label.addEventListener("click", setTab);
  label.addEventListener("keydown", enterEvent);
});

const toggleTitle = (e) => {
  const tab = e.currentTarget;
  if (!tab.classList.contains("active-tab")) {
    const container = document.getElementById(tab.dataset.container);
    const { item } = tab.dataset;

    container.querySelectorAll(".standard-tab-label").forEach((label) => {
      if (label === tab) {
        label.classList.add("active-tab");
        label.setAttribute("aria-selected", "true");
      } else {
        label.classList.remove("active-tab");
        label.setAttribute("aria-selected", "false");
      }
    });
    container.querySelectorAll(".tab-item").forEach((content) => {
      if (content.classList.contains(item)) {
        content.classList.remove("none");
        content.setAttribute("aria-hidden", "false");
      } else {
        content.classList.add("none");
        content.setAttribute("aria-hidden", "true");
      }
    });
  }
};

document.querySelectorAll(".standard-tab-label").forEach((label) => {
  label.addEventListener("click", toggleTitle);
  label.addEventListener("keydown", enterEvent);
});

const triggerStudioModal = (e) => {
  e.preventDefault();
};

document.querySelectorAll(".non-customer-like-button").forEach((button) => {
  button.addEventListener("click", triggerStudioModal);
  button.addEventListener("keydown", enterEvent);
});

const checkCarouselButtons = () => {
  document
    .querySelectorAll(".horizontal-carousel-container")
    .forEach((container) => {
      const carousel = container.querySelector(".horizontal-carousel");
      if (carousel) {
        const carouselWidth = carousel.offsetWidth;
        const innerCarousel = carousel.querySelector("div").offsetWidth;
        if (innerCarousel < carouselWidth) {
          container.querySelectorAll(".carousel-button").forEach((button) => {
            button.classList.add("hide-carousel-buttons");
          });
        } else {
          container.querySelectorAll(".carousel-button").forEach((button) => {
            button.classList.remove("hide-carousel-buttons");
          });
        }
      }
    });
};

checkCarouselButtons();

const checkCarouselPosition = () => {};

const sitemapLinkClick = (e) => {
  e.preventDefault();
};

document.querySelectorAll(".sitemap-link").forEach((link) => {
  link.addEventListener("click", sitemapLinkClick);
  link.addEventListener("keydown", enterEvent);
});

if (window.location.pathname.indexOf("/products") === 0) {
  const getCurrentVariant = (product) => {
    if (!product || !Array.isArray(product.variants)) {
      console.error("product or product variants not found");
      return null;
    }

    const variantSelect = document.querySelector(".variant-select");
    if (!variantSelect) {
      console.warn(
        "Variant select element not found, returning the default variant",
      );
      return product.variants[0];
    }

    const selectedOption = Array.from(
      variantSelect.querySelectorAll("option"),
    ).find((option) => option.selected);
    if (!selectedOption) {
      console.warn("No selected option found, returning the default variant");
      return product.variants[0];
    }

    const variantId = selectedOption.value;
    const variant = product.variants.find((v) => v.id == variantId);
    if (!variant) {
      console.warn(
        "Selected variant does not exist in product, returning the default variant",
      );
      return product.variants[0];
    }

    return variant;
  };

  // Send new product view when color changes
  window.addEventListener("productChange", (e) => {
    const newProduct = e.detail;
    const newVariant = getCurrentVariant(newProduct);
    trackProductView(newProduct, newVariant);
  });

  fetch(`${window.location.pathname}.js`)
    .then((response) => response.json())
    .then((product) => {
      const variant = getCurrentVariant(product);
      trackProductView(product, variant);
    })
    .catch((e) => {
      throw new Error(e);
    });
}

window.cleanInput = (e) => {
  const input = e.currentTarget;
  let { value } = input;
  if (input.dataset.case == "lc") {
    value = input.value.toLowerCase();
  }
  if (input.dataset.case == "uc") {
    value = input.value.toUpperCase();
  }
  if (input.dataset.verify == "Chars") {
    value = value
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z/A-Z ]/g, "");
  } else if (input.dataset.verify == "couple") {
    value = value
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z/A-Z /+]/g, "");
    if (value.length == 2 && value.charAt(1) !== "+") {
      value = `${value.charAt(0)}+${value.charAt(1)}`;
    }
  } else {
    value = value
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z/A-Z ]/g, "");
  }

  input.value = value;
  verifyInput(input);
  if (input.classList.contains("personalizer")) {
    document.querySelectorAll(".personalization-text").forEach((text) => {
      text.textContent = input.value;
      window.testFontSize();
    });
  }
};

window.cleanKeys = (e) => {
  const input = e.srcElement;
  if (input.dataset.verify == "couple") {
    if (!/[a-z /+]/i.test(String.fromCharCode(e.keyCode))) {
      e.preventDefault();
      return false;
    }
  } else if (!/[a-z ]/i.test(String.fromCharCode(e.keyCode))) {
    e.preventDefault();
    return false;
  }
};

window.verifyIt = (e) => {
  verifyInput(e.currentTarget);
};

const resetMobility = () => {
  isMobile = window.matchMedia("(max-width: 768px)");
};

const scrollToAnchor = (e) => {
  e.preventDefault();
  const anchor = document.getElementById(e.currentTarget.href.split("#")[1]);
  const scrollPosition = anchor.offsetTop;
  anchor.focus();
  window.scrollTo({
    top: scrollPosition,
    left: 0,
    behavior: "smooth",
  });
};

const setRealWeddingsGallery = (gallery, product, key) => {
  getCustomGallery(gallery, product, key).then((data) => {
    let instaContainer = ``;
    data.forEach((post, index) => {
      let prev = null;
      let next = null;
      if (index !== 0) {
        prev = `real-weddings-insta-object-${index - 1}`;
      }
      if (index < data.length) {
        next = `real-weddings-insta-object-${index + 1}`;
      }
      instaContainer += `
<div class="insta-image cursor-pointer insta-image-${index}" data-prev="${prev}" data-next="${next}" data-timestamp="${
        post.timestamp
      }" data-image="${post.src}" data-caption="${post.caption}"
data-products='${JSON.stringify(
        post.products,
      )}' data-hashtags='${JSON.stringify(post.hashtags)}' data-user="${
        post.user
      }" data-profilepic="${
        post.profile_pic
      }" data-index="${index}" id="real-weddings-insta-object-${index}">
<div class="relative square-container">
<picture>
<img alt="${
        post.caption
      }" height="280" width="280" loading="eager" class="w-full !h-full !max-w-full !max-h-full object-cover" src="${
        post.src
      }"  />
</picture>
</div>
      </div>

  `;
    });

    realWeddingsGrid.innerHTML = instaContainer;
    document.querySelectorAll(".insta-image").forEach((insta) => {
      insta.addEventListener("click", showInsta);
      insta.addEventListener("keydown", enterEvent);
    });
  });
};

let realWeddingsGrid = document.getElementById("real-weddings-insta-grid");
if (realWeddingsGrid) {
  setRealWeddingsGallery(
    realWeddingsGrid.dataset.gallery,
    realWeddingsGrid.dataset.product,
    stampedKey,
  );
}

const changeRealWeddingsGallery = (e) => {
  const { value } = e.currentTarget;
  setRealWeddingsGallery(value, "", stampedKey);
};

const uncheckGallery = (e) => {
  const button = e.currentTarget;
  let radio = button.getAttribute("for");
  radio = document.getElementById(radio);
  if (radio && radio.checked) {
    setTimeout(() => {
      radio.checked = false;
    }, 25);
    setRealWeddingsGallery(
      realWeddingsGrid.dataset.gallery,
      realWeddingsGrid.dataset.product,
      stampedKey,
    );
  }
};

document.querySelectorAll(".real-wedding-gallery-label").forEach((label) => {
  label.addEventListener("click", uncheckGallery);
  label.addEventListener("keydown", enterEvent);
});

document.querySelectorAll(".real-wedding-insta-option").forEach((option) => {
  option.addEventListener("change", changeRealWeddingsGallery);
});

const pauseVideo = (e) => {
  e.preventDefault();
  const videoContainer = e.currentTarget;
  const video = videoContainer.querySelector("video");
  const button = videoContainer.querySelector(".play-button");
  if (!video || !button) return;
  video.classList.remove("cursor-pointer");
  video.pause();
  button.classList.remove("hidden");
  button.parentElement?.classList.add("z-10");
  videoContainer.removeEventListener("click", pauseVideo);
  videoContainer.removeEventListener("keydown", enterEvent);
};

const playVideo = (e) => {
  const isDesktop = window.matchMedia("min-width:768px").matches;
  e.preventDefault();
  const button = e.currentTarget;
  const videoContainer = button.parentElement.parentElement;
  const video = videoContainer?.querySelector("video");
  const stylingVideo = videoContainer.querySelector(".styling-video");
  const stylingPlayButton = document.querySelector(
    ".pdp-thumb .video-play-button",
  );
  const internalTitleCard = document.querySelector(".styling-video-title");
  if (!video || videoContainer === null) return;
  if (stylingVideo) stylingVideo.setAttribute("controls", true);
  if (video.paused) {
    button.classList.add("hidden");
    button.parentElement?.classList.remove("z-10");
    video.play();
    setTimeout(() => {
      if (!isDesktop) {
        if (stylingVideo) {
          stylingPlayButton.classList.add("hidden");
          if (internalTitleCard) internalTitleCard.classList.add("hidden");
        } else {
          videoContainer.addEventListener("click", pauseVideo);
          videoContainer.addEventListener("keydown", enterEvent);
        }
      }
    }, 10);
  }
};

const resetFocusOutline = () => {
  document.querySelector("body").classList.remove("no-focus-outline");
  document.querySelector("body").classList.add("focus-outline");
};

const trapSearchFocus = (e) => {
  const focusableEls = document.querySelectorAll(
    "#desktop-search-ui a[href]:not([disabled]), #desktop-search-ui button:not([disabled]), #desktop-search-ui textarea:not([disabled]), #desktop-search-ui input, #desktop-search-ui select, #desktop-search-icon .desktop-search-close, #popular-search-box a[href]:not([disabled]), #popular-search-box button:not([disabled]), #popular-search-box textarea:not([disabled]), #popular-search-box input:not([disabled]), #popular-search-box select:not([disabled]), .header-container a[href]:not([disabled]), .header-container button:not([disabled]), .header-container textarea:not([disabled]), .header-container input:not([disabled]), .header-container select:not([disabled])",
  );
  const firstFocusableEl = focusableEls[0];
  const lastFocusableEl = focusableEls[focusableEls.length - 1];
  const KEYCODE_TAB = 9;
  const isTabPressed = e.key === "Tab" || e.keyCode === KEYCODE_TAB;

  if (e.key === "Escape") {
    resetFocusOutline();
    closeDesktopSearch();
  }
  if (!isTabPressed) {
    return;
  }

  if (e.shiftKey) {
    if (document.activeElement === firstFocusableEl) {
      lastFocusableEl.focus();
      e.preventDefault();
    }
  } else if (document.activeElement === lastFocusableEl) {
    firstFocusableEl.focus();
    e.preventDefault();
  }
};

const trapMobileSearchFocus = (e) => {
  const focusableEls = document.querySelectorAll(
    "#mobile-search-box a[href]:not([disabled]), #mobile-search-box button:not([disabled]), #mobile-search-box textarea:not([disabled]), #mobile-search-box input, #mobile-search-box select, #popular-search-box a[href]:not([disabled]), #popular-search-box button:not([disabled]), #popular-search-box textarea:not([disabled]), #popular-search-box input:not([disabled]), #popular-search-box select:not([disabled])",
  );
  const firstFocusableEl = focusableEls[0];
  const lastFocusableEl = focusableEls[focusableEls.length - 1];
  const KEYCODE_TAB = 9;
  const isTabPressed = e.key === "Tab" || e.keyCode === KEYCODE_TAB;

  if (!isTabPressed) {
    return;
  }

  if (e.shiftKey) {
    if (document.activeElement === firstFocusableEl) {
      lastFocusableEl.focus();
      e.preventDefault();
    }
  } else if (document.activeElement === lastFocusableEl) {
    firstFocusableEl.focus();
    e.preventDefault();
  }
};

const handleDesktopSearchKeyboardEvents = (e) => {
  if (e.key === "Escape") {
    closeDesktopSearch();
  }
};

const openDesktopSearch = (e) => {
  const button = e.currentTarget;
  const parent = button.parentElement.parentElement;
  if (parent.classList.contains("open-search")) {
    const searchInput = document.querySelector(".desktop-search-input").value;
    if (searchInput == "") {
      parent.classList.remove("open-search");
      document
        .getElementById("popular-search-box")
        ?.classList.remove("open-search");
      document.getElementById("desktop-search-ui")?.classList.add("invisible");
      document.getElementById("popular-search-box")?.classList.add("invisible");
      document
        .querySelector("body")
        .removeEventListener("click", closeSearchBody);
    } else {
      document.getElementById("desktop-search-form").submit();
    }
  } else {
    const searchInput = document.querySelector(".desktop-search-input");
    if (searchInput) {
      setTimeout(() => {
        searchInput.focus();
      }, 1);
    }
    parent.classList.add("open-search");
    document.getElementById("desktop-search-ui").classList.remove("invisible");
    document
      .getElementById("popular-search-box")
      ?.classList.remove("invisible");
    document.getElementById("popular-search-box")?.classList.add("open-search");
    document.querySelector("body").addEventListener("click", closeSearchBody);
    document.addEventListener("keydown", handleDesktopSearchKeyboardEvents);
  }

  document
    .querySelector("#popular-search-box")
    ?.addEventListener("keydown", trapSearchFocus);

  document
    .querySelector(".header-container")
    ?.addEventListener("keydown", trapSearchFocus);
};

const closeDesktopSearch = () => {
  document
    .getElementById("desktop-search-icon")
    .classList.remove("open-search");
  document
    .getElementById("popular-search-box")
    ?.classList.remove("open-search");
  document.querySelector("body").removeEventListener("click", closeSearchBody);
  document.removeEventListener("keydown", handleDesktopSearchKeyboardEvents);
  document
    .querySelector("#popular-search-box")
    ?.removeEventListener("keydown", trapSearchFocus);
  document
    .querySelector(".header-container")
    ?.removeEventListener("keydown", trapSearchFocus);
  document.body.classList.remove("ss__autocomplete--active");
  document.querySelector(".desktop-search-container-content").focus();
  resetFocusOutline();
};

const openMobileSearch = (e) => {
  const button = e.currentTarget;
  const searchBox = document.getElementById("mobile-search-box");
  if (!button.classList.contains("active-search")) {
    button.classList.add("active-search");
    button.classList.add("stroke1");
    searchBox.classList.add("open-mobile-search");
    document.getElementById("popular-search-box")?.classList.add("open-search");
    document.getElementById("popular-search-box")?.classList.add("visible");
    document
      .getElementById("popular-search-box")
      ?.classList.remove("invisible");
    document.getElementById("mobile-search-ui")?.classList.remove("invisible");
    document.getElementById("mobile-search-ui")?.classList.add("visible");
    document.getElementById("mobile-search-box")?.focus();
    document.querySelector(".mobile-search-input")?.focus();

    button.removeEventListener("click", openMobileSearch);
    button.addEventListener("click", closeMobileSearch);
    setTimeout(() => {
      document.querySelector("body").addEventListener("click", closeSearchBody);
    }, 10);
  }

  document
    .querySelector("#popular-search-box")
    ?.addEventListener("keydown", trapMobileSearchFocus);
};

const mobileSearch = (e) => {
  const form = document.getElementById("mobile-search-form");
  const { value } = document.querySelector(".mobile-search-input");
  if (value !== "") {
    form.submit();
  } else {
    closeMobileSearch(null);
  }
};

const closeSearchBody = (e) => {
  const body = e.currentTarget;
  const header = document.querySelector("header");
  if (!header.contains(e.target) && !e.target.contains(header)) {
    document
      .getElementById("desktop-search-icon")
      .classList.remove("open-search");
    document
      .getElementById("popular-search-box")
      ?.classList.remove("open-search");
    body.removeEventListener("click", closeSearchBody);
  }
};

const closeMobileSearch = (e) => {
  const button = document.getElementById("mobile-search-button");
  const searchBox = document.getElementById("mobile-search-box");
  button.classList.remove("active-search");
  button.classList.remove("stroke1");
  button.addEventListener("click", openMobileSearch);
  button.removeEventListener("click", closeMobileSearch);
  searchBox.classList.remove("open-mobile-search");
  document
    .getElementById("popular-search-box")
    ?.classList.remove("open-search");
  document.getElementById("popular-search-box")?.classList.remove("visible");
  document.getElementById("mobile-search-ui").classList.remove("visible");
  document.querySelector("body").removeEventListener("click", closeSearchBody);
  document
    .querySelector("#popular-search-box")
    ?.removeEventListener("keydown", trapMobileSearchFocus);
};

const mobileSearchIcon = document.getElementById("mobile-search-button");
if (mobileSearchIcon) {
  mobileSearchIcon.addEventListener("click", openMobileSearch);
  mobileSearchIcon.addEventListener("keydown", enterEvent);
  document
    .querySelector(".mobile-close-search")
    .addEventListener("click", closeMobileSearch);
  document
    .querySelector(".mobile-close-search")
    .addEventListener("keydown", enterEvent);
  document
    .querySelector(".mobile-search-icon")
    .addEventListener("click", mobileSearch);
  document
    .querySelector(".mobile-search-icon")
    .addEventListener("keydown", enterEvent);
}

const desktopSearchIcon = document.getElementById("desktop-search-icon");
if (desktopSearchIcon) {
  desktopSearchIcon
    .querySelector(".desktop-search-container-content")
    .addEventListener("click", openDesktopSearch);
  desktopSearchIcon
    .querySelector(".desktop-search-container-content")
    .addEventListener("keydown", enterEvent);
  desktopSearchIcon
    .querySelector(".desktop-search-close")
    .addEventListener("click", closeDesktopSearch);
  desktopSearchIcon
    .querySelector(".search-icon")
    .addEventListener("keydown", enterEvent);
  desktopSearchIcon
    .querySelector(".desktop-search-close")
    .addEventListener("keydown", enterEvent);
}

document.querySelectorAll(".play-button").forEach((button) => {
  button.addEventListener("click", playVideo);
  button.addEventListener("keydown", enterEvent);
});

document.querySelectorAll(".anchor-link").forEach((anchor) => {
  anchor.addEventListener("click", scrollToAnchor);
  anchor.addEventListener("keydown", enterEvent);
});

const useConfig = () => {
  const { shop } = window.Shopify;
  const ENVIRONMENT =
    shop === "birdygrace.myshopify.com" ? "production" : "development";
  const config = {
    development: {
      platform_url: "https://platform.birdystaging.com/api",
    },
    production: {
      platform_url: "https://platform.birdygrey.com/api",
    },
  };

  const { platform_url: platformURL } = config[ENVIRONMENT];
  return { platformURL };
};

const submitFooterEmail = (e) => {
  const { platformURL } = useConfig();
  const button = e.currentTarget;
  const date = document.getElementById("footer-wedding-date");
  const email = document.getElementById("footer-email-address");
  let valid = true;
  let role;
  const now = Date.now();
  const body = {
    initialTS: now,
    popupTS: now + 15000,
    submitTS: now + 20000,
    bot: 0,
    signupLocation: "footer",
  };
  document.querySelectorAll(".footer-role-radio").forEach((radio) => {
    if (radio.checked) {
      role = radio.value;
      const hasRole =
        role == "bride" ||
        role == "bridesmaid" ||
        role == "groomsman" ||
        role == "groom" ||
        role == "just shopping";

      if (hasRole) body.role = role;
      else valid = false;
    }
  });
  if (date.value) {
    const validDate =
      /^\d{4}[/-](0?[1-9]|1[012])[/-](0?[1-9]|[12][0-9]|3[01])$/.test(
        date.value,
      );
    if (!validDate) valid = false;
    else body.date = date.value;
  }
  const validEmail =
    /^(?=.*[@])(?=.*\.com)[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
      email.value,
    );

  const emailErrorMessage = document.querySelector(".email-form-error-message");
  if (!validEmail) {
    // if the email is not valid, show the error-message block and adjust input border color to red.
    valid = false;
    emailErrorMessage.classList.remove("hidden");
    email.classList.add("border-brand-errorText");
    email.classList.add("!text-brand-errorText");
  } else {
    body.email = email.value;
    emailErrorMessage.classList.add("hidden");
    email.classList.remove("border-brand-errorText");
    email.classList.remove("!text-brand-errorText");
  }

  if (valid) {
    button.removeEventListener("click", submitFooterEmail);
    button.removeEventListener("keydown", enterEvent);
    button.innerText = "SIGNING UP...";
    fetch(`${platformURL}/v1/customer/signup`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
      .then((res) => res.json())
      .then((response) => {
        button.innerText = "YOU'RE IN!";
        trackLead(body.email, { signup_location: "footer", list_id: "Hj8m3A" });
      })
      .catch((err) => {
        console.error(err);
        button.innerText = "SIGN UP";
      });
  }
};

const footerEmailSubmit = document.getElementById("footer-email-submit");
if (footerEmailSubmit) {
  footerEmailSubmit.addEventListener("click", submitFooterEmail);
  footerEmailSubmit.addEventListener("keydown", enterEvent);
}

window.addEventListener("resize", checkCarouselButtons);
window.addEventListener("resize", checkCarouselPosition);
window.addEventListener("resize", resetMobility);

const cartSuccess = (lines, newCart, klaviyoProduct) => {
  if (!lines || !Array.isArray(lines.items)) {
    console.error("cartSuccess: lines.items should be a non-empty array");
    return;
  }

  lines.items.forEach((line) => {
    trackAddToCart(line, newCart, klaviyoProduct);

    const attributionKey = line.key;
    const attributionId = line.id;

    let cart_attribution = {};
    if (localStorage.atc_attribution) {
      try {
        cart_attribution = JSON.parse(localStorage.atc_attribution);
      } catch (err) {
        console.error("Invalid JSON in atc_attribution", err);
      }
    }

    if (!cart_attribution[attributionKey]) {
      cart_attribution[attributionKey] = {};
    }

    if (attributionId) cart_attribution[attributionKey].line_id = attributionId;
    if (localStorage.iS)
      cart_attribution[attributionKey].initial_source = localStorage.iS;
    if (localStorage.iM)
      cart_attribution[attributionKey].initial_medium = localStorage.iM;
    if (localStorage.iC)
      cart_attribution[attributionKey].initial_campaign = localStorage.iC;
    if (localStorage.iCo)
      cart_attribution[attributionKey].initial_content = localStorage.iCo;
    if (localStorage.iT)
      cart_attribution[attributionKey].initial_timestamp = localStorage.iT;
    if (localStorage.vS)
      cart_attribution[attributionKey].visit_source = localStorage.vS;
    if (localStorage.vM)
      cart_attribution[attributionKey].visit_medium = localStorage.vM;
    if (localStorage.vC)
      cart_attribution[attributionKey].visit_campaign = localStorage.vC;
    if (localStorage.vCo)
      cart_attribution[attributionKey].visit_content = localStorage.vCo;
    if (localStorage.vT)
      cart_attribution[attributionKey].visit_timestamp = localStorage.vT;

    cart_attribution[attributionKey].atc_ts = Date.now();
    localStorage.atc_attribution = JSON.stringify(cart_attribution);
  });
};

const buildVimeoVideo = (e) => {
  window.focusReturn = e.currentTarget;
  const { video } = e.currentTarget.dataset;
  const modalContent = `<div class="w-screen h-[56.25vw] max-w-[60rem] max-h-[calc(60rem*0.5625)]">
    <iframe class="size-full" src="https://player.vimeo.com/video/${video}?texttrack=en-x-autogen&amp;color=ACD5C0&amp;title=0&amp;byline=0&amp;portrait=0;" allow="autoplay; fullscreen" allowfullscreen="" width="1920" height="1080" frameborder="0">
    </iframe></div>
  `;
  buildModal(modalContent);
};

document.querySelectorAll(".vimeo-popup").forEach((vimeo) => {
  vimeo.addEventListener("click", buildVimeoVideo);
  vimeo.addEventListener("keydown", enterEvent);
});

const buildStepsPopup = (e) => {
  window.focusReturn = e.currentTarget;
  const { steps } = e.currentTarget.dataset;
  const { image } = e.currentTarget.dataset;
  const modalContent = `
    <div class="p-4">
    <div class="grid measurement-grid justify-center gap-4">
    <div class="w-72 justify-self-center">
    <picture>
    <img width="600" height="900" class="bg-blushPink" loading="eager" src="${image}">
    </picture>
    </div>
    <div class="min-w-72">
    ${steps}
    </div>
    </div>
    </div>
  `;
  buildModal(modalContent);
};

document.querySelectorAll(".steps-popup").forEach((steps) => {
  steps.addEventListener("click", buildStepsPopup);
  steps.addEventListener("keydown", enterEvent);
});

const activateDress = (e) => {
  const container = e.currentTarget;
  if (container.classList.contains("active-dress")) {
    container.classList.remove("active-dress");
  } else {
    container.classList.add("active-dress");
  }
};

document.querySelectorAll(".meet-dresses-item").forEach((item) => {
  item.addEventListener("click", activateDress);
  item.addEventListener("keydown", enterEvent);
});

// ACCOUNT PAGE FIXES
const showRecovery = () => {
  const recoverForm = document.getElementById("RecoverPasswordForm");
  const recoverHeading = document.querySelector(".reset-password-heading");
  const loginHeading = document.querySelector(".login-heading");
  if (recoverForm) {
    if (recoverForm.classList.contains("none")) {
      recoverHeading.classList.remove("none");
      loginHeading.classList.add("none");
      recoverForm.classList.remove("none");
      document.getElementById("CustomerLoginForm").classList.add("none");
    } else {
      recoverForm.classList.add("none");
      recoverHeading.classList.add("none");
      loginHeading.classList.remove("none");
      document.getElementById("CustomerLoginForm").classList.remove("none");
    }
  }
};

if (
  window.location.pathname === "/account/login" &&
  window.location.hash === "#recover"
) {
  showRecovery();
}

document.querySelectorAll(".recover-password").forEach((recover) => {
  recover.addEventListener("click", showRecovery);
  recover.addEventListener("keydown", enterEvent);
});

const equalizeScroll = (e) => {
  const scrolled = e.currentTarget;
  const offset = scrolled.scrollLeft;

  document.querySelectorAll(".reward-grid").forEach((grid) => {
    if (grid !== scrolled) {
      grid.scrollLeft = offset;
    }
  });
};

document.querySelectorAll(".reward-grid").forEach((grid) => {
  grid.addEventListener("scroll", equalizeScroll);
});

const correctForm = (e) => {
  e.preventDefault();
  const form = e.currentTarget;
  const input = form.querySelector("input");
  const value = input.value.toLowerCase();
  if (value.includes("rose quartz") || value.includes("dessert rose")) {
    input.value = "Desert Rose";
  }
  if (value.includes("terra cotta") || value.includes("teracotta")) {
    input.value = "Terracotta";
  }
  if (value.includes("gwinnie") || value.includes("gweenie")) {
    input.value = "Gwennie";
  }
  if (value.includes("devon")) {
    input.value = "Devin";
  }
  if (value.includes("bowtie")) {
    input.value = "bow tie";
  }
  form.submit();
};
const desktopSearchForm = document.getElementById("desktop-search-form");
const mobileSearchForm = document.getElementById("mobile-search-form");

if (desktopSearchForm) {
  desktopSearchForm.addEventListener("submit", correctForm);
}
if (mobileSearchForm) {
  mobileSearchForm.addEventListener("submit", correctForm);
}
